/* =================================
		BACK TO TOP
==================================== */
window.requestAnimationFrame =
  window.requestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  function (timeOutFn) {
    return setTimeout(timeOutFn, 1000 / 60);
  };
window["prism2412"] = function () {
  if (
    typeof jQuery == "function" &&
    !document.getElementsByClassName("running2412").length &&
    document.getElementsByClassName("header-wrap").length
  ) {
    document.body.classList.add("running2412");
    applychanges2412();
    jQuery(window).scroll(function () {
      if (jQuery(window).scrollTop() > 100) {
        jQuery(".scrollToTopArrow").stop(true).fadeIn();
      } else {
        jQuery(".scrollToTopArrow").stop(true).fadeOut();
      }
    });
    jQuery(window).scroll();
    //console.log("Main Function Running. (running2412)");
  } else if (!document.getElementsByClassName("running2412").length) {
    window.requestAnimationFrame(prism2412);
  }
};
prism2412();
function applychanges2412() {
  var smallinit = setInterval(function () {
    if (!jQuery(".scrollToTopArrow").length) {
      jQuery("body").append(
        '<div id="backtotop" class="scrollToTopArrow">Top</div>',
      );
      jQuery(document).on("click", ".scrollToTopArrow", function () {
        jQuery("body, html").animate({ scrollTop: "0" }, 600);
      });
      clearInterval(smallinit);
    } else {
      setTimeout(function () {
        clearInterval(smallinit);
      }, 5000);
    }
  }, 100);
}
(function (d, s, id) {
  var js,
    fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  js = d.createElement(s);
  js.id = id;
  js.src = "https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js";
  fjs.parentNode.insertBefore(js, fjs);
})(document, "script", "facebook-jssdk");

/* =============================================
  		PAYMENT OPTIONS
  		- GRAB, ATOME, PACE
================================================ */
function isTouchScreendevice() {
  let isMobile = window.matchMedia(
    "only screen and (max-width: 760px)",
  ).matches;

  if (isMobile) {
    return "ontouchstart" in window || navigator.maxTouchPoints;
  }
}

if (isTouchScreendevice()) {
  $(".main-content").addClass("touch");
  $(".main-content").removeClass("notouch");
  $(".tooltip .open").click(function () {
    $(".tooltip").removeClass("active");
    $(this).parent(".tooltip").toggleClass("active");
    $(this).parent().parent(".tooltip").toggleClass("active");
    $(".stockclose").addClass("show bgshow");
  });

  $(".tooltiptext .close").click(function () {
    $(".tooltip").removeClass("active");
    $(".stockclose").removeClass("show bgshow");
  });
} else {
  $(".main-content").removeClass("touch");
  $(".main-content").addClass("notouch");
  $(document)
    .on("mouseenter", ".tooltip .open", function (event) {
      // 🚫 skip tooltips inside payment-alt-options
      if ($(this).closest(".payment-alt-options").length) return;

      $(".tooltip").removeClass("active");

      const $tooltip = $(this).closest(".tooltip");
      $tooltip.addClass("active");

      // if nested tooltip exists
      $tooltip.parent().closest(".tooltip").addClass("active");
    })
    .on("mouseleave", ".tooltip .open", function () {
      if ($(this).closest(".payment-alt-options").length) return;

      $(".tooltip").removeClass("active");
    });
    $(document).on("click", ".payment-alt-options .tooltip .open", function (e) {
      //e.stopPropagation();

      const $tooltip = $(this).closest(".tooltip");
      // toggle current
      $tooltip.toggleClass("active");
      $(".stockclose").addClass("show bgshow");
  });
}
jQuery(document).ready(function ($) {
  $(".payment-alt-options .grab-btn").click(function () {
    $(".grabpay-modal-main").addClass("active");
    $("body").addClass("modal-active");
    //var price = $(".grab-box").attr("data-price");
    var price = $(".grab-box .grab-btn .price-value").text();
    $(".grabpay-content .price span").text(price);
    $(".stockclose").addClass("show bgshow");
  });

  
  
  $(".payment-alt-options .atome-btn").click(function () {
    $(".atomepay-modal").addClass("active");
  });

  $(".payment-alt-options .pace-btn").click(function () {
    $(".pacepay-modal").addClass("active");
  });
  $(".payment-alt-options .grabpay-close").click(function () {
    $(".pay-alt-modal").removeClass("active");
  });

  $(".allbnpl-btn").click(function () {
    $(".allbnpl-modal").addClass("active");
    var price = $(".grab-box").attr("data-price");
    $(".grabpay-content .price span").text(price);

    $(".stockclose").addClass("show bgshow");
  });
  $(".zendesk-launch").click(function () {
    $(
      "button.wrapper-3hgZT.u-isActionable.u-textLeft.u-inlineBlock.u-borderNone.u-textBold.u-textNoWrap.Arrange.Arrange--middle.u-userLauncherColor.wrapperMobile-2S6wV",
    ).click();
    $("iframe#launcher").click();
  });

  var productTitle = $(".product-single__title").text();
  var prodPrice = $("#ProductPrice-product-template")
    .text()
    .trim()
    .replace("$", "");
  var contentName = `${productTitle}`;

  var pri = prodPrice;
  pri = pri.replace(/\,/g, ""); // 1125, but a string, so convert it to number
  pri = parseInt(pri, 10);

  try {
    if (meta.product) {
      var ttqObj = {
        content_name: contentName,
        content_category: meta.product.type,
        content_id: meta.product.id,
        content_type: "product_group",
        value: pri,
        quantity: 1,
        currency: "SGD",
      };
      ttq.track("ViewContent", ttqObj);
    }
  } catch (error) {
    console.error(error);
  }
});

/* =============================================
  		STOCK INDICATOR AND POPOVER
================================================ */
jQuery(document).ready(function ($) {
  $(".stock-wrap-nov2 .tooltip").click(function () {
    $(".stock-wrap-nov2 .classic .popover").addClass("show");
    $(".stockclose").addClass("show");
  });
  $(document)
    .on(
      "mouseenter",
      ".stock-wrap-nov2 .tooltip",
      ".infoicon",
      function (event) {
        $(".stock-wrap-nov2 .popover").addClass("show");
      },
    )
    .on("mouseleave", ".stock-wrap-nov2 .tooltip", ".infoicon", function () {
      $(".stock-wrap-nov2 .popover, .infoicon").removeClass("show");
    });
  $(".stockclose, .grabpay-close").click(function () {
    $(".stock-wrap-nov2 .popover, .infoicon").removeClass("show");
    $(".stockclose").removeClass("show");
    $(".stockclose").removeClass("bgshow");
    $(".prodCont").removeClass("show");
    $(".tooltip").removeClass("active");
    $(".allbnpl-modal").removeClass("active");
    $(".grabpay-modal-main, .oasis-bnpl-modal").removeClass("active");
    $(
      ".oasis-chart-modal, .oasis-size-modal,  .zero-btu-modal, .oasisv2-size-modal, .oasisv2-smart-modal",
    ).removeClass("active");
    $("body").removeClass("tooltipopen modal-active");
  });

  $(".voucher-wrap .tooltip .open").click(function () {
    $(".stockclose").addClass("bgshow");
  });

  $(".tooltiptext .close").click(function () {
    $(".tooltip").removeClass("active");
    $(".stockclose").removeClass("show");
    $(".stockclose").removeClass("bgshow");
  });

  $(".open-btu").click(function () {
    $(".zero-btu-modal").addClass("active");
    $(".stockclose").addClass("show bgshow");
  });

  $(document).keyup(function (e) {
    if (e.which == 27) {
      $(".stock-wrap-nov2 .popover").removeClass("show");
      $(".stockclose, .infoicon").removeClass("show");
      $(".stockclose").removeClass("bgshow");
      $(".prodCont").removeClass("show");
      $(".tooltip").removeClass("active");
      $(".allbnpl-modal").removeClass("active");
      $(".oasis-bnpl-modal").removeClass("active");
      $(".oasis-chart-modal, .oasis-size-modal, .v2-size-modal").removeClass(
        "active",
      );
    }
  });
});
/* =============================================
  		AIRCON TECHSPECS FIX
================================================ */
jQuery(document).ready(function ($) {
  $(".aircons .vwo_specs .vwo_specTitle").click(function () {
    if (window.matchMedia("(max-width:767px)").matches) {
      $(this).parent.toggleClass("active");
      //$('.vwo_specBlock').not($(this).parent('.vwo_specBlock')).removeClass('active');
      if ($(this).parent(".vwo_specBlock.active").length) {
        $("html,body").animate(
          {
            scrollTop: $(this).offset().top - 10,
          },
          200,
        );
      }
    }
  });
});

/* =============================================
  		PRODUCT GROUPSELL
================================================ */
jQuery(document).ready(function ($) {
  updateStockIndicator();

  $(".groupsell-wrap .prodCont").slick({
    dots: false,
    infinite: false,
    arrows: false,
    slidesToShow: 2,
    slidesToScroll: 1,
  });
  $(window).resize(function () {
    $(".groupsell-wrap .prodCont")[0]?.slick.refresh();
  });
  if ($(window).width() < 1023) {
    $(".groupsell-wrap .infoicon").click(function () {
      $(".stockclose, .infoicon").addClass("show");
      $(".prodCont").addClass("show");
      $(".stockclose").addClass("bgshow");
    });
  }
  $(document).on("mouseleave", ".groupsell-wrap .infoicon", function () {
    $(".stockclose, .infoicon").removeClass("show");
    $(".prodCont").removeClass("show");
    $(".stockclose").removeClass("bgshow");

  });
  var tempcheckout = $(".product-form__checkout").attr("href");
  var tempcart = $(".product-form__cart").attr("href");
  $(".checkout-hdden").val(tempcheckout);
  $(".cart-hdden").val(tempcart);

  $(".click-plus").click(function () {
    $(".groupsell-one .newsalebox2:has(.click-plus)").removeClass("selected");
    
    $(".groupsell-one .bundled-addon-selectors .addon-box").removeClass(
      "active",
    );

    if ($(".bundled-addon-selectors").length) {
      setTimeout(function () {
        $(".bundled-addon-selectors.selected .select-wrapper .addon-box")
          .first()
          .click();
        console.log("selector clicked");
        if ($(".bundled-addon-selectors").hasClass("selected")) {
          $(".selectedgroupsell").text("");
        }
      }, 300);
    }

    var cart = $(".cart-hdden").val();
    var orig = $(".checkout-hdden").val();

    // ✅ Reset states when unchecking
    if ($(this).hasClass("clicked")) {
      $(this)
        .prev('input[name="bundle_prod"]')
        .prop("checked", false)
        .trigger("change");
      $(".product-form__checkout").attr("href", orig);
      $(".product-form__cart").attr("href", cart);
      $(".selectedgroupsell").text("");
      $("#ProdBundle").attr({
        "data-vid": "",
        "data-vtitle": "",
        "data-vprice": "",
      });
      $(".click-plus").removeClass("clicked");
      $(".newsalebox2").removeClass("selected");
      resetBundleInitial();
      
      // reset main price when soundbar unchecked
      // const mainPrice = $(`#ProductSelect-product-template option[value="${$("#ProductSelect-product-template").val()}"]`)?.attr("data-price")?.replaceAll(",","").replaceAll(".","") || 0;
      // const mainCompare = $(`#ProductSelect-product-template option[value="${$("#ProductSelect-product-template").val()}"]`)?.attr("data-compare-price")?.replaceAll(",","").replaceAll(".","").replaceAll("$","") || 0;
      // $("#currentSelection").attr("data-price", (mainPrice / 100).toFixed(2));
      // $("#currentSelection").attr("data-compare", Number(mainCompare).toFixed(2));
      // updatePrice();
      // updateVoucher();

      return; // stop here
    }

    // ✅ Reset others and mark this as clicked
    $(".groupsell-one .click-plus").removeClass("clicked");
    $("#prism-sentinel-8662946513123 .newsalebox2").removeClass("selected"); // target only sentinel to reduce breaking of groupsell on other pdps
    $(".product-form-product-template-aura .groupsell-wrap .newsalebox2").removeClass("selected"); // target only AP
    $(".product-form-product-template-aura .groupsell-wrap .click-plus").removeClass("clicked"); // target only AP
    $(this).addClass("clicked");
    $(this).prev('input[name="bundle_prod"]').prop("checked", true);

    // check if groupsell has bundled selectors and reset
    var bundleAddon = $("#currentSelection").attr("data-addon-bundled");
    if (bundleAddon) {
      var handle = $("#currentSelection").attr("data-handle");
      var liMatch = document.querySelector(
        `.combo-list li[data-handle="${handle}"]`,
      );

      if (liMatch) {
        var oldVariantID = liMatch.dataset.variant; // SAFE
        $("#currentSelection").attr("data-variant", oldVariantID);
        //console.log("Found variant via <li>: ", oldVariantID);
      } else {
        //console.log("No LI match for handle:", handle);
      }
    }

    checkSingleGroupsell();
    // ✅ Toggle selected on parent box
    $("#prism-sentinel-8662946513123 .newsalebox2").removeClass("selected");
    const $selectedBox = $(this).closest(".newsalebox2");
    $(".groupsell-one .newsalebox2").removeClass("selected");
    $selectedBox.addClass("selected");

    // ✅ Get current selected variant info
    var selectedVariant = $("#currentSelection").attr("data-variant");
    var quantitySel = $("#currentSelection").attr("data-quantity");
    var quantity = quantitySel !== "" ? quantitySel : "1";

    // ✅ Update selected groupsell ID
    const $checkedInput = $(this).prev('input[name="bundle_prod"]:checked');
    const GrpId = $checkedInput.val();
    const GrpType = $checkedInput.attr("data-vtype");
    const GrpBundles = $checkedInput.attr("data-bundled-variants");
    const GrpTitle = $(".newsalebox2.selected .prodName2").text();
    const GrpPrice = $(".newsalebox2.selected .prodprice2 .newprice").text();


    // 🧠 Before:
    // $(".selectedgroupsell").text(GrpId);

    if ($(".groupsell-wrap").hasClass("auto-bundle-variants")) {
      console.log(
        "⚙️ auto-bundle-variants mode → skipping selectedgroupsell update",
      );
      $(".selectedgroupsell").text("");
    } else {
      $(".selectedgroupsell").text(GrpId);
    }

    groupsell_variant_select();
    updateLinks();

    // Update price when soundbar addon is selected (tv pdp)
    // const soundbarPrice = $(".newsalebox2.selected input")?.attr("data-price") || 0;
    // const tvPrice = $(`#ProductSelect-product-template option[value="${$("#ProductSelect-product-template").val()}"]`)?.attr("data-price")?.replaceAll(",","").replaceAll(".","") || 0;
    // const finalPrice = Number(tvPrice) + Number(soundbarPrice);
    // const tvCompare = $(`#ProductSelect-product-template option[value="${$("#ProductSelect-product-template").val()}"]`)?.attr("data-compare-price")?.replaceAll(",","").replaceAll(".","").replaceAll("$","") || 0;
    // const finalCompare = (Number(tvCompare) * 100) + Number(soundbarPrice);
    // $("#currentSelection").attr("data-price", (finalPrice / 100).toFixed(2));
    // $("#currentSelection").attr("data-compare", (finalCompare / 100).toFixed(2));
    // updatePrice();
    // updateVoucher();

    /* check gropusell fix */
    const dzWrap = $(".groupsell-wrap");
    const dzProdBundle = $("#ProdBundle");
    const selectedgroupsell = $(".selectedgroupsell").text().trim();

    // 👉 current selected input
    const dzSelectedInput = $(".newsalebox2.selected").find(
      "input[type='radio']",
    );

    // main ID
    const dzGrpId = String(dzSelectedInput.val() || "");

    if (!dzGrpId) {
      console.warn("No selected groupsell ID");
      return;
    }

    if (dzWrap.hasClass("single-groupsell")) {

      return;

    } else if (
      dzWrap.hasClass("prodbundle") 
    ) {


      if (dzGrpId === selectedgroupsell) {

        console.log("my1on1");

        $(".selectedgroupsell").text("");
        bundleIDgroupsellFix();

      } else {

        console.log("mytwo");
        bundleIDgroupsellFix();

      }

    } else {

      bundleIDgroupsellFix();

    }

    function bundleIDgroupsellFix() {
      dzProdBundle.attr({
        "data-vid": GrpId,
        "data-vtitle": GrpTitle,
        "data-vprice": GrpPrice,
        "data-vtype": GrpType,
        "data-gp2-id": GrpId,
        "data-gp2-bundled-ids": GrpBundles,
      });
    }
    /* ORIGINAL */
    // ✅ AUTO BUNDLE GROUPSELL — update addon-selected-bundle + bundled IDs
    (function () {
      const $wrap = $(".auto-bundle-variants");
      var includeGroupsell = $(".auto-bundle-variants").attr(
        "data-include-groupsell",
      );
      var autoSelectGroupsell = $(".auto-bundle-variants").attr(
        "data-auto-select",
      );
      var $selectedOptionID = $(
        "#ProductSelect-product-template option:selected",
      ).val();

      if (!$wrap.length) return;

      function updateBundleDisplay() {
        /* remove bundled ids since we auto add them (hidden) */
        $("#ProdBundle").removeAttr("data-gp2-id data-gp2-bundled-ids");
        // ✅ Find selected box (or fallback to first)
        let $selectedBox = $wrap.find(".newsalebox2.selected");
        if (!$selectedBox.length) {
          $selectedBox = $wrap.find(".newsalebox2").first();
          if ($selectedBox.length) {
            $selectedBox.addClass("selected");
          } else {
            console.warn("⚠️ No .newsalebox2 found in .auto-bundle-variants");
            return;
          }
        }

        // ✅ Find input
        const $input = $selectedBox
          .find("input[data-bundled-variants]")
          .first();
        if (!$input.length) {
          console.warn(
            "⚠️ No input[data-bundled-variants] found in selected box",
          );
          return;
        }

        // ✅ Combine variant IDs
        if (includeGroupsell == "true") {
          var mainId = $input.val() || ""; //selected groupsell ID
        } else {
          var mainId = "";
          //switch current selection to use the groupsellID, this is for the bundling of bundled variants to be paired with the current groupsellID
          //$('#currentSelection').attr('data-variant', $input.val());
          //place the main product's ID as the groupsell
          //$('.selectedgroupsell').text($selectedOptionID);
        }
        const extraIds = $input.attr("data-bundled-variants") || "";
        const bundledIds = [mainId, ...extraIds.split(",")]
          .map((id) => id.trim())
          .filter((id) => id !== "")
          .filter((id, i, arr) => arr.indexOf(id) === i)
          .join(",");

        // ✅ Get title (data-select-title or fallback to .prodName2)
        const selectTitle =
          $input.attr("data-select-title") ||
          $.trim($selectedBox.find(".prodName2").text()) ||
          "";

        // ✅ Update the label text
        if (selectTitle) {
          $(".addon-selected-bundle").text(selectTitle);
          console.log("🟢 addon-selected-bundle updated:", selectTitle);
        }

        // ✅ Update currentSelection + option data

        if (bundledIds) {
          if (includeGroupsell == "true") {
            $("#currentSelection").attr("data-bundled-variant-ids", bundledIds);
            const $selectedOption = $(
              "#ProductSelect-product-template option:selected",
            );
            if ($selectedOption.length) {
              $selectedOption.attr("data-bundled-variant-ids", bundledIds);
            }
          } else {
            $("#currentSelection").attr("data-bundled-variant-ids", bundledIds);
            const $selectedOption = $(
              "#ProductSelect-product-template option:selected",
            );
            if ($selectedOption.length) {
              $selectedOption.attr("data-bundled-variant-ids", bundledIds);
            }
          }
        }

        // ✅ Run bundle refresh logic if available
        if (typeof checkBundledVariants === "function") {
          checkBundledVariants();
        }
      }
      $("#ProdBundle").attr(
        "data-gp2-bundled-ids",
        $(this)
          .prev('input[name="bundle_prod_2"]')
          .attr("data-bundled-variants"),
      );
      // ✅ Run once on load
      updateBundleDisplay();

      if (autoSelectGroupsell == "true") {
        // ✅ Update when user selects another bundle
        $wrap.on("click", ".newsalebox2", function () {
          const $clicked = $(this);
          if ($clicked.hasClass("selected")) return;
          $wrap.find(".newsalebox2").removeClass("selected");
          $clicked.addClass("selected");
          updateBundleDisplay();
        });
      }
    })();
  });

  function checkSingleGroupsell() {
    // check if groupsell has bundled selectors and reset on click
    // issue scenario why this was made: if bundle was clicked, and then the other groupsell was clicked, the bundle does not go back to the original main variant ID
    var bundleAddon = $("#currentSelection").attr("data-addon-bundled");
    if (bundleAddon) {
      var handle = $("#currentSelection").attr("data-handle");
      var liMatch = document.querySelector(
        `.combo-list li[data-handle="${handle}"]`,
      );

      if (liMatch) {
        var oldVariantID = liMatch.dataset.variant; // SAFE
        $("#currentSelection").attr("data-variant", oldVariantID);
        console.log("Found variant via <li>: ", oldVariantID);
      } else {
        console.log("No LI match for handle:", handle);
      }
    }
  }

  /* ====== groupsell second *======== */

  $(".click-plus-2").click(function () {

    /*
     * Get the groupsell-second container that was clicked.
     * Selection is ONLY managed inside this container.
     *
     * This means:
     * - One option per groupsell-second container
     * - Other groupsell-second containers are untouched
     * - .groupsell-set-main can remain selected
     */
    const $currentContainer = $(this).closest(".groupsell-wrap");

    const $currentBox = $(this).closest(".newsalebox2");


    function updateLinks2(checked, variantId) {
      let selectedVariant = $("#currentSelection").attr("data-variant");
      let quantity = $("#currentSelection").attr("data-quantity") || 1;

      let selectedGroupsell = $(".selectedgroupsell").text();
      let selectedGroupsell2 = $(".selectedgroupsell-second").text();
      var selectedVariantID = $(".selected_variantId").text().trim();

      const gp2Id = $("#ProdBundle").attr("data-gp2-id");


      /* -----------------------
          HANDLE SELECTION LOGIC
        ----------------------- */

      if (checked && variantId) {

        $(".selectedgroupsell-second").text(variantId);
        selectedGroupsell2 = variantId;

      } else if (!checked) {

        $(".selectedgroupsell-second").text("");
        selectedGroupsell2 = "";

      }


      /* -----------------------
          BUILD CHECKOUT LINK
        ----------------------- */

      let checkParts = [`${selectedVariant}:${quantity}`];

      if (selectedGroupsell) {
        checkParts.push(`${selectedGroupsell}:${quantity}`);
      }

      // ONLY include groupsell-second if it DOES NOT match gp2-id
      if (selectedGroupsell2 && selectedGroupsell2 !== gp2Id) {
        checkParts.push(`${selectedGroupsell2}:${quantity}`);
      }

      if (selectedVariantID) {
        checkParts.push(`${selectedVariantID}:${quantity}`);
      }

      let checklink = checkParts.join(",");


      /* -----------------------
            BUILD CART LINK
        ----------------------- */

      let cartParts = [
        `id[]=${selectedVariant}&quantity=${quantity}`
      ];

      if (selectedGroupsell) {
        cartParts.push(
          `id[]=${selectedGroupsell}&quantity=${quantity}`
        );
      }

      if (selectedGroupsell2 && selectedGroupsell2 !== gp2Id) {
        cartParts.push(
          `id[]=${selectedGroupsell2}&quantity=${quantity}`
        );
      }

      if (selectedVariantID) {
        cartParts.push(
          `id[]=${selectedVariantID}&quantity=${quantity}`
        );
      }

      let cartlink = "/cart/add?" + cartParts.join("&");


      /* -----------------------
            APPLY UPDATED LINKS
        ----------------------- */

      $(".product-form__checkout").attr(
        "href",
        "/cart/" + checklink
      );

      $(".product-form__cart").attr(
        "href",
        cartlink
      );


      console.log("✔ gp2-id =", gp2Id);
      console.log("✔ Selected 2nd groupsell =", selectedGroupsell2);
      console.log(
        "✔ Updated checkout link:",
        "/cart/" + checklink
      );
      console.log(
        "✔ Updated cart link:",
        cartlink
      );
    }


    /* =====================================================
       ALREADY SELECTED
    ===================================================== */

    if ($(this).hasClass("clicked")) {

      // Uncheck this option
      $(this)
        .prev('input[name="bundle_prod_2"]')
        .prop("checked", false);

      $(this)
        .prev('input[name="bundle_prod_2"]')
        .trigger("change");


      /*
       * Remove clicked ONLY inside this container.
       */
      $currentContainer
        .find(".click-plus-2")
        .removeClass("clicked");


      /*
       * Remove selected ONLY from this option/container.
       */
      $currentBox.removeClass("selected");


      $("#ProdBundle").attr("data-gp2-id", "");
      $("#ProdBundle").attr("data-vtitle", "");
      $("#ProdBundle").attr("data-gp2-bundled-ids", "");


      updateLinks2(false);

    }


    /* =====================================================
       NOT SELECTED
    ===================================================== */

    else {

      /*
       * Deselect other options ONLY in the same container.
       *
       * IMPORTANT:
       * We are no longer touching other groupsell-second
       * containers.
       */
      $currentContainer
        .find(".click-plus-2")
        .removeClass("clicked");


      $currentContainer
        .find(".newsalebox2:has(.click-plus-2)")
        .removeClass("selected");


      /*
       * Select clicked option.
       */
      $(this).addClass("clicked");


      $(this)
        .prev('input[name="bundle_prod_2"]')
        .prop("checked", true);


      $(this)
        .prev('input[name="bundle_prod_2"]')
        .trigger("change");


      $currentBox.addClass("selected");


      updateLinks2(
        true,
        $(this)
          .prev('input[name="bundle_prod_2"]')
          .val()
      );


      $("#ProdBundle").attr(
        "data-gp2-id",
        $(this)
          .prev('input[name="bundle_prod_2"]')
          .val()
      );


      $("#ProdBundle").attr(
        "data-vtitle",
        $(this)
          .prev('input[name="bundle_prod_2"]')
          .attr("data-attr")
      );


      $("#ProdBundle").attr(
        "data-gp2-bundled-ids",
        $(this)
          .prev('input[name="bundle_prod_2"]')
          .attr("data-bundled-variants")
      );
    }


    updatePrice();
});
  /* end of click for groupsell */
  /* =====================
END OF GROUPSELL
======================== */
  $(".product-form__variants2").change(function () {
    // for tv variants
    var tvid = this.value;
    var bundle = $(this)
      .children("option:selected")
      .attr("data-bundled-variant-ids");
    var orig = $(".product-form__checkout").attr("href");
    var cart = $(".product-form__cart").attr("href");
    var GrpTitle = $(this).children("option:selected").attr("data-title");
    var GrpPrice = $(this).children("option:selected").attr("data-price");
    var GrpType = $(this).children("option:selected").attr("data-vtype");
    var Groupsell = $(".selectedgroupsell").text();

    if (tvid != "-") {
      $("#currentSelection").attr("data-variant", tvid);
    }

    if (bundle == undefined) {
      /* if no bundle is found */
      $(".product-form__checkout").attr("href", "/cart/" + tvid + ":1");
      $(".product-form__cart").attr(
        "href",
        "/cart/add?id[]=" + tvid + "&quantity1",
      );
    } else {
      //$('#currentSelection').attr("href", bundles);
      var bundles = bundle.split(",");
      if (bundles.length > 1) {
        var chitems = [];
        var items = [];
        var ctitems;
        for (var i = 0; i < bundles.length; i++) {
          chitems.push(bundles[i] + ":1");
          items.push("&id[]=" + bundles[i] + "");
        }
        //items.push("&id[]="+Groupsell+"");
        //console.log(items.join(""));
        ctitems = items.join("");
        $(".product-form__checkout").attr(
          "href",
          "/cart/" + tvid + ":1," + chitems,
        );
        $(".product-form__cart").attr(
          "href",
          "/cart/add?id[]=" + tvid + ctitems + "&quantity1",
        );
      } else {
        var hasBundle = bundle && bundle !== "" && bundle !== "0";
        console.log("mybundle" + bundle);
        // ---------- Checkout URL ----------
        var checkoutUrl = "/cart/" + tvid + ":1";

        if (hasBundle) {
          checkoutUrl += "," + bundle + ":1";
        }

        $(".product-form__checkout").attr("href", checkoutUrl);

        // ---------- Add to Cart URL ----------
        var cartUrl = "/cart/add?id[]=" + tvid;

        if (hasBundle) {
          cartUrl += "&id[]=" + bundle;
        }

        $(".product-form__cart").attr("href", cartUrl);

        $("#ProdBundle").attr("data-vid", bundle);
        $("#ProdBundle").attr("data-vtitle", GrpTitle);
        $("#ProdBundle").attr("data-vprice", GrpPrice);
        $("#ProdBundle").attr("data-vtype", GrpType);
      }
    }
  });

  /* =========================
  Consolidated function to update add to cart and buy now links
  - the links includes groupsell and quantity options
  ============================ */

  /* Quantity selector */
  /* quantity add to cart */
  //$('#aura-qty').val("5");
  var input = $("#aura-qty"),
    minValue = parseInt(input.attr("min"));

  $(".qty-increase").on("click", function () {
    var inputValue = input.val();
    var newInput = input.val(parseInt(inputValue) + 1);
    input.val(parseInt(inputValue) + 1);
    $("#currentSelection").attr("data-quantity", newInput.val());
    updateLinks();
  });
  $(".qty-decrease").on("click", function () {
    var inputValue = input.val();
    if (inputValue >= 2) {
      input.val(parseInt(inputValue) - 1);
      var newInput = input.val(parseInt(inputValue) - 1);
      $("#currentSelection").attr("data-quantity", newInput.val());
      updateLinks();
    }
  });
});

/* FUNCTION IF COLOR VARIANT SELECTION IS ENABLED */

jQuery(document).ready(function ($) {
  // get current variant

  var curSelection = $("#currentSelection");
  if (curSelection.length > 0) {
    var initialVariant = $("#currentSelection").attr("data-variant");

    var initialColor = $("#currentSelection").attr("data-color");
    var initialColorText = initialColor?.replace("-", " ");
    //set initial defaults
    if (initialVariant != "") {
      $(".product-single__thumbnails-items." + initialColor).addClass("active");
      $(".colorbox-select .variant-sentry-space-grey.initial").click();
      $(
        ".product-single__thumbnails-items.main." + initialColor + " a",
      ).addClass("active-thumb");
      $(".colorbox-select .item.variant-" + initialColor).addClass("active");
      $(".variant-select .variant-color").text(initialColorText);
      updateThumbnail();
    }
  }

  //on click / variant select
  $(".colorbox-select li").click(function () {
    //console.log('clicked');
    var clickedVariant = $(this).attr("id");
    //console.log(clickedVariant);
    var dataSelected = $(this).attr("data-selected");
    console.log("my selected variant:" + clickedVariant);
    if (!clickedVariant) return;
    if (!$(".ProductSelect-product-template").length) return;

    var updatePrice = $(
      ".ProductSelect-product-template option[value= " + clickedVariant + "]",
    )
      .attr("data-myprice")
      .replace(",", "");
    var updateCompare = $(
      ".ProductSelect-product-template option[value= " + clickedVariant + "]",
    ).attr("data-compare");
    var updateColor = $(
      ".ProductSelect-product-template option[value= " + clickedVariant + "]",
    ).attr("data-title");

    var colorText = $(
      ".ProductSelect-product-template option[value= " + clickedVariant + "]",
    )
      .attr("data-title")
      .replace("-", " ");
    var dataDisplay = $(
      ".ProductSelect-product-template option[value= " + clickedVariant + "]",
    ).attr("data-display");
    var updateSave = $(
      ".ProductSelect-product-template option[value= " + clickedVariant + "]",
    ).attr("data-compare-diffrent");
    var updateDiff = $(
      ".ProductSelect-product-template option[value= " + clickedVariant + "]",
    ).attr("data-compare-percentage");
    var getVoucher = $(
      ".ProductSelect-product-template option[value= " + clickedVariant + "]",
    ).attr("data-variantVoucher");
    var updateRestock = $(
      ".ProductSelect-product-template option[value= " + clickedVariant + "]",
    ).attr("data-restock");
    var updateIndicator = $(
      ".ProductSelect-product-template option[value= " + clickedVariant + "]",
    ).attr("data-stockIndicator");
    var updateTimer = $(
      ".ProductSelect-product-template option[value= " + clickedVariant + "]",
    ).attr("data-timer-value");
    var updateAtc = $(
      ".ProductSelect-product-template option[value= " + clickedVariant + "]",
    ).attr("data-atc");

    //var updateColor = updateColor2.replace('-', ' ');
    //console.log(updateColor);
    //var updateVoucher = updatePrice - getVoucher;

    var getGrab = $(".payment-alt-options .grab-info").attr("data-discount");
    var updateGrab = updatePrice / getGrab;
    var getAtome = $(".payment-alt-options .atome-info").attr("data-discount");
    var updateAtome = updatePrice / getAtome;
    var priceInt = updatePrice.replace(/,/g, "");
    var compareInt = updateCompare.replace(/,/g, "");
    var updateVoucher = priceInt - getVoucher;

    // update grab and atome values
    // console.log(updateAtome);
    // console.log(updateGrab);

    //$("#currentSelection").attr("data-stockNum", updateIndicator);
    $(".variant-select .variant-color").text(dataSelected);
    if (dataDisplay) {
      $(".variant-select .variant-color.variant-group").text(dataDisplay);
    }
    $(".colorbox-select li, .product-single__thumbnails-items").removeClass(
      "active",
    );
    console.log("clicked variant: " + clickedVariant);
    $("#currentSelection").attr("data-variant", clickedVariant);
    $("#currentSelection").attr("data-variant-timer", updateTimer);
    $("a#initateCheckout").text(updateAtc);

    $(".product-single__thumbnails-items.main a").removeClass("active-thumb");
    $(".product-single__thumbnails-items.main." + updateColor + " a").addClass(
      "active-thumb",
    );

    /* stock indicator for color selection */
    var stockIndicator = $(
      ".ProductSelect-product-template option[value= " + clickedVariant + "]",
    ).attr("data-stockIndicatorNum");
    console.log("stock-indicator:" + stockIndicator);
    $("#currentSelection").attr("data-stockNum", stockIndicator);

    /* update price */
    $("span#ProductPrice-product-template").text("$" + updatePrice);
    $("s#ComparePrice-product-template").text("$" + updateCompare);
    $(".payment-alt-options .grab-info .price-value").text(
      Math.round(Number(updateGrab)),
    );
    $(".payment-alt-options .atome-info .price-value").text(
      Math.round(Number(updateAtome)),
    );
    $("#compare_save").html(updateSave);
    //console.log(updateDiff);
    $("#compare_precntage, .comparetooltip").text(updateDiff);

    $(".product-single__thumbnails-items." + updateColor).addClass("active");
    $(this).addClass("active");

    $("#voucher-price").text("$" + updateVoucher.toLocaleString());
    //console.log("voucher price:" + updateVoucher);
    // update climate voucher price
    var ClimateVoucher = updateVoucher - window.cv_price;
    if (ClimateVoucher < 0) {
      var displayClimate = 0;
    } else {
      var displayClimate = `$${(
        updateVoucher - window.cv_price
      ).toLocaleString()}`;
    }
    $(".voucher-pricing .tooltip .voucher-wrap .voucher-price").html(
      displayClimate,
    );

    $(".product-form__cart span.voucher1").text(
      "$" + updateVoucher.toLocaleString(),
    );
    $(".custom-attributes.product-restocks p").html(
      "<b>" + updateRestock + "</b>",
    );

    $("#currentSelection").attr("data-price", priceInt);
    $("#currentSelection").attr("data-compare", compareInt);
    $("#currentSelection").attr("data-voucher", getVoucher);

    /* update variant */
    updateLinks();
    updateThumbnail();
    updateDeliveryTimer();
    data_display();
  });

  /* techspecs */
  $("#Specs, #Specs2").click(function () {
    $(".keyspecifications .vwo_specTitle").click();
  });
  $("#guideSpecs").click(function () {
    $(".charges .vwo_specTitle").click();
  });
});
function updateThumbnail() {
  jQuery(".product-single__thumbnails-items.main a.active-thumb").click();
}

/* FUNCTION TO UPDATE LINKS */
function updateLinks() {
  /* update if bundled variant */
  addOnBundle();
  /* get current variant */
  var selectedVariant = $("#currentSelection").attr("data-variant");

  /* get current quantity */
  var quantity = $("#currentSelection").attr("data-quantity") || 1;

  /* selected groupsell items */
  var selectedGroupsell = $(".selectedgroupsell").text().trim();
  var selectedGroupsell2 = $(".selectedgroupsell-second").text().trim();
  var selectedVariantID = $(".selected_variantId").text().trim();

  /* -----------------------
        BUILD CHECKLINK
    ----------------------- */
  let checkParts = [`${selectedVariant}:${quantity}`];

  if (selectedGroupsell) {
    checkParts.push(`${selectedGroupsell}:${quantity}`);
  }

  if (selectedGroupsell2) {
    checkParts.push(`${selectedGroupsell2}:1`);
  }
  if (selectedVariantID) {
    checkParts.push(`${selectedVariantID}:1`);
  }

  let checklink = checkParts.join(",");

  /* -----------------------
        BUILD CART LINK
    ----------------------- */
  let cartParts = [`id[]=${selectedVariant}`, `quantity=${quantity}`];

  if (selectedGroupsell) {
    cartParts.push(`id[]=${selectedGroupsell}`, `quantity=${quantity}`);
  }

  if (selectedGroupsell2) {
    cartParts.push(`id[]=${selectedGroupsell2}`, `quantity=1`);
  }
  if (selectedVariantID) {
    cartParts.push(`id[]=${selectedVariantID}`, `quantity=1`);
  }

  let cartlink = "/cart/add?" + cartParts.join("&");

  /* -----------------------
        APPLY LINKS
    ----------------------- */
  $(".product-form__checkout").attr("href", "/cart/" + checklink);
  $(".product-form__cart").attr("href", cartlink);

  updateStockIndicator();
}
function updatePrice() {
  //console.log("update price function");
  var updatePrice = $("#currentSelection").attr("data-price");
  var updateCompare = $("#currentSelection").attr("data-compare");

  updatePrice = parseFloat(updatePrice.replace(/,/g, "")) * 100;
  updateCompare = parseFloat(updateCompare.replace(/,/g, "")) * 100;

  const list = ["/products/doors", "/products/gates"];
  if (list.some((x) => location.pathname.indexOf(x) !== -1)) {
    let addOnPrice = 0;

    const addOnBox = $(".newsalebox2.selected");
    if (addOnBox.length) {
      let price = addOnBox.find(".newprice:not(.hide)");
      if (price.length) {
        price =
          parseFloat(price.html().replace("$", "").replace(/,/g, "")) * 100;
        addOnPrice += price;
      }
    }

    updatePrice += addOnPrice;
  }
  $("span#ProductPrice-product-template").text(
    theme.Currency.formatMoney(updatePrice).replace(".00", ""),
  );
  //$("#AddToCart-button .voucher1").text(theme.Currency.formatMoney(updatePrice).replace('.00', ''));
  $("s#ComparePrice-product-template").text(
    theme.Currency.formatMoney(updateCompare).replace(".00", ""),
  );
}
function updateInstallment() {
  var price = $("#currentSelection").attr("data-price") || "0";
  var comparePrice = $("#currentSelection").attr("data-compare") || "0";

  price = parseFloat(price.replace(/,/g, "")) || 0;
  comparePrice = parseFloat(comparePrice.replace(/,/g, "")) || 0;

  // Round to nearest whole number
  $(".payment-alt-options .price-value.grab-info").text(Math.round(price / 4));
  $(".payment-alt-options .price-value.atome-info").text(Math.round(price / 3));
}
function updateVoucher() {
  //console.log("update voucher");
  /* update voucher and grab/atome values */
  var updatePrice = $("#currentSelection").attr("data-price");
  var getVoucher = $("#currentSelection").attr("data-voucher");
  var getGrab = $(".payment-alt-options .grab-info").attr("data-discount");
  var getAtome = $(".payment-alt-options .atome-info").attr("data-discount");
  var updateVoucherText = $("#currentSelection").attr("data-voucherText");

  var priceInt = Number(updatePrice.replace(/,/g, ""));
  var voucherInt = Number(getVoucher);
  var grabInt = Number(getGrab);
  var atomeInt = Number(getAtome);

  var updateGrab = priceInt / grabInt;
  var updateAtome = priceInt / atomeInt;
  var updateVoucher = priceInt - voucherInt;

  var updateCV = updateVoucher - window.cv_price;
  updateCV = updateCV < 0 ? 0 : updateCV;
  //console.log("price" + priceInt);
  //console.log("voucher" + updateVoucher);
  $("#voucher-price, .voucher1").text("$" + updateVoucher.toLocaleString());
  $(
    ".product-price-wrap  .voucher-pricing .tooltip .voucher-wrap .voucher-price",
  ).text("$" + updateCV.toLocaleString());
  $(".payment-alt-options .grab-info .price-value").text(
    Math.ceil(Number(updateGrab)).toLocaleString(),
  );
  $(".payment-alt-options .pay-details .price span").text(
    Math.round(Number(updateGrab)),
  );
  $(".payment-alt-options .atome-info .price-value").text(
    Math.round(Number(updateAtome)),
  );
  $(".voucher-pricing .tooltip .flex-wrap .part1 p.code .dynamicCode").html(
    updateVoucherText,
  );
  //console.log("end update voucher");
}
/* FUNCTION TO CHANGE DELIVERY TIMER */
/* update delivery timer information */
function updateDeliveryTimer() {
  jQuery(document).ready(function ($) {
    /* get current variant timer*/
    var variantTimer = $("#currentSelection").attr("data-variant-timer");

    if (variantTimer == 1 || variantTimer == "1") {
      $(".product-restocks .main-restock").css("display", "block");
      $(".product-restocks .variant-restock").css("display", "none");
      console.log("display timer");
    } else {
      $(".product-restocks .main-restock").css("display", "none");
      $(".product-restocks .variant-restock").css("display", "block");
      console.log("hide timer");
    }
  });
}

/* FUNCTION IF COMBO VARIANT SELECTION IS ENABLED 
currently, the liquid is specific for warranty 
*/

$("select.combo-dropown").change(function () {
  var comboval = this.value;
  var combox = $(".box-item.active").attr("data-option");
  $(".selected-model").text(comboval);

  $(".combo-select").text(comboval + " - " + combox);
  comboVariant();
});
$(".combo-boxes .box-item").click(function () {
  var comboval = $(".selected-model").text();
  var combox = $(this).attr("data-option");
  var comboxText = $(this).text();

  $(".combo-boxes li").removeClass("active");
  $(this).addClass("active");
  $(".selected-coverage").text(comboxText);
  $(".combo-select").text(comboval + " - " + combox);
  console.log("combox:" + combox);
  /* manually change overlay image based on selected year */
  if (combox == "8 Years Extended Warranty") {
    $(".warranty-with-overlay .product-single__photos .overlay-image").attr(
      "src",
      "https://prismplus.sg/cdn/shop/files/EW-Overlay-8yrs.png?v=1752739513",
    );
  } else if (combox == "5 Years Extended Warranty") {
    console.log("5years");
    $(".warranty-with-overlay .product-single__photos .overlay-image").attr(
      "src",
      "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/EW-Overlay-5yrs.png?v=1751432372",
    );
  } else {
    console.log("default");
    $(".warranty-with-overlay .product-single__photos .overlay-image").attr(
      "src",
      "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/EW-Overlay-3yrs.png?v=1759988984",
    );
  }
  comboVariant();
});
$(document).on("click", ".dummy-selector .item", function () {
    const show = $(this).data("show");

    // Switch to the corresponding model
    $(".combo-dropown option." + show + ":first").prop("selected", true);

    // Trigger the existing dropdown logic
    $(".combo-dropown").trigger("change");
});

jQuery(document).ready(function ($) {
  /* ------------------------------------------
     Utility: Wait until elements exist
  ------------------------------------------- */
  function waitForElement(selector, callback) {
    const check = setInterval(() => {
      if ($(selector).length) {
        clearInterval(check);
        callback();
      }
    }, 50);
  }

  /* ------------------------------------------
     Main Warranty Initialization Logic
  ------------------------------------------- */
  function runWarrantyInitialization() {
    const urlParams = new URLSearchParams(window.location.search);
    const pathname = location.pathname;
    const selectedVariant = urlParams.get("variant");

    const pages = {
      refrigerator: "/prism-refrigerator-extended-warranty",
      tv: "/prism-tv-extended-warranty",
      laundry: "/prism-washer-dryer-extended-warranty",
      solaris: "/prism-solaris-extended-warranty",
      nanobot: "/prism-nanobot-extended-warranty",
      ceilingfan: "/prism-ceiling-fan-extended-warranty",
      smartlock: "/prism-smart-lock-extended-warranty",
    };

    const isPage = {
      refrigerator: pathname.includes(pages.refrigerator),
      tv: pathname.includes(pages.tv),
      laundry: pathname.includes(pages.laundry),
      solaris: pathname.includes(pages.solaris),
      nanobot: pathname.includes(pages.nanobot),
      ceilingfan: pathname.includes(pages.ceilingfan),
      smartlock: pathname.includes(pages.smartlock),
    };

    /* ------------------------------------------------------------
      UNIFIED FIX: Handle ?variant=undefined → auto-select first
    ------------------------------------------------------------- */
    if (selectedVariant === "undefined") {
      console.warn(
        "⚠️ Variant was undefined → selecting first available option automatically.",
      );

      // GRAB FIRST DROPDOWN OPTION
      let firstModel = $(".combo-dropown option").first().val();

      // GRAB FIRST WARRANTY OPTION
      let $firstWarranty = $(".combo-boxes .box-item").first();
      let firstWarrantyText = $firstWarranty.attr("data-option");

      // Build a fallback title (same structure as variant titles)
      let fallbackTitle = `${firstModel} – ${firstWarrantyText}`;

      console.log("Fallback Title:", fallbackTitle);

      // Apply dropdown
      $(".combo-dropown").val(firstModel).trigger("change");

      // Apply warranty
      $firstWarranty.trigger("click");

      // STOP reload behavior
      return;
    }

    /* ------------------------------------------
       Default fallback selections
    ------------------------------------------- */
    const initialClicks = () => {
      $(
        ".colorbox-select .item.active, .colorbox-select.initial.active",
      ).trigger("click");
      $(".combo-boxes li").first().trigger("click");
      $(".product-group-variants .group-selector.active li")
        .first()
        .trigger("click");
      $(".box-item").first().trigger("click");
    };

    /* ------------------------------------------
       Universal Variant → Model + Warranty Logic
    ------------------------------------------- */
    function applyVariantSelection() {
      if (!selectedVariant) {
        initialClicks();
        return;
      }

      const $li = $(`.combo-list [data-variant="${selectedVariant}"]`).first();
      if (!$li.length) {
        initialClicks();
        return;
      }

      // Extract full variant title
      const fullTitle = $li.data("title") || "";
      console.log("FULL VARIANT TITLE:", fullTitle);

      // Split on ANY dash: "-", "–", "—"
      let parts = fullTitle.split(/\s*[-–—]\s*/);

      let model = parts[0]?.trim() || "";
      let warranty = parts[1]?.trim() || "";

      console.log("MODEL:", model);
      console.log("WARRANTY:", warranty);

      /* ------------------------------------------
         Apply Model to Dropdown (if matching)
      ------------------------------------------- */
      const $dropdown = $(".combo-dropown");

      if ($dropdown.find(`option[value="${model}"]`).length) {
        console.log("APPLY MODEL:", model);
        $dropdown.val(model).trigger("change");
      } else {
        console.warn("Model NOT found in dropdown → skipping:", model);
      }

      /* ------------------------------------------
         Apply Warranty to box-item (if matching)
      ------------------------------------------- */

      // Normalize text helper
      function normalize(str) {
        return (str || "")
          .trim()
          .toLowerCase()
          .replace(/extended\s*warranty/gi, "")
          .replace(/\s+/g, " ")
          .trim();
      }

      // PART 1: Normalize warranty text from variant title
      let cleanWarranty = normalize(warranty); // Example: "5 years"

      // PART 2: Try to find matching data-option EXACTLY first
      let $matchExact = $(`.combo-boxes [data-option="${warranty}"]`);

      // If exact match fails, try partial/loose matching
      let $matchLoose = $();
      if (!$matchExact.length) {
        $(".combo-boxes [data-option]").each(function () {
          let option = $(this).attr("data-option");
          if (normalize(option).includes(cleanWarranty)) {
            $matchLoose = $(this);
            return false; // break loop
          }
        });
      }

      // Apply whichever match is found
      if ($matchExact.length) {
        console.log("APPLY EXACT WARRANTY:", warranty);
        $matchExact.first().trigger("click");
      } else if ($matchLoose.length) {
        console.log("APPLY LOOSE WARRANTY:", $matchLoose.attr("data-option"));
        $matchLoose.first().trigger("click");
      } else {
        console.warn(
          "Warranty NOT found in combo-boxes:",
          warranty,
          cleanWarranty,
        );
      }
    }

    /* ------------------------------------------
       Apply logic only to warranty pages
    ------------------------------------------- */
    if (
      isPage.refrigerator ||
      isPage.tv ||
      isPage.laundry ||
      isPage.solaris ||
      isPage.nanobot ||
      isPage.ceilingfan ||
      isPage.smartlock
    ) {
      applyVariantSelection();
    } else {
      initialClicks();
    }

    /* ------------------------------------------
     Missing text on dropdown select on initial load
    ------------------------------------------- */
    $(function () {
      if (!$(".selected-model").text().trim()) {
          $(".selected-model").text(
              $(".combo-dropown option:selected").text() ||
              $(".combo-dropown option:first").text()
          );
      }
    });
    /* ------------------------------------------
       Optional callbacks (if defined)
    ------------------------------------------- */
    data_display?.();
    groupsel_variant_initial?.();
  }

  
  /* ------------------------------------------
     Start only when all DOM elements are loaded
  ------------------------------------------- */
  waitForElement(
    ".combo-list li, .combo-boxes li, .combo-dropown, .colorbox-select",
    runWarrantyInitialization,
  );
  // 🔄 Refresh thumbnail after fallback selection
  setTimeout(() => {
    // updateThumbnail?.();
    jQuery(".product-single__thumbnails-items.main a.active-thumb").click();
  }, 2200);
});

function warrantyPDP() {
  $(".product-selector-wrapper").css("border-top", "0px");
  $(".product-selector-wrapper").css("padding-top", "0px");
  const selectedVariant = urlParams.get("variant");
  if (!selectedVariant) {
    initialClicks();
  } else {
    const ele = $(`.combo-list [data-variant="${selectedVariant}"]`)[0];
    if (!ele) {
      initialClicks();
    } else {
      const title = $(ele).data("title").split(" - ");
      const model = title[0];
      const coverage = title[1];
      // console.log(model);
      // console.log(coverage);
      $(".combo-dropown").val(model).change();
      $(`.combo-boxes [data-option="${coverage}"]`)[0].click();
    }
  }
}
/* for simple selector */
$(".simple-selector .box-item").click(function () {
  var selectedVariant = $(this).attr("data-id");
  var selectedTitle = $(this).attr("data-title");
  $("#currentSelection").attr("data-variant", selectedVariant);
  $(".combo-select").text(selectedTitle);
  comboVariant();
  updateThumbnail();
  updateLinks();
  updatePrice();
});
function comboVariant() {
  var comboselect = $(".combo-select").text();
  name = comboselect
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-$/, "")
    .replace(/^-/, "");
  //get variant from combolist
  console.log(name);
  var clickedVariant = $(".combo-list ." + name).attr("data-variant");
  var clickedImage = $(".combo-list ." + name).attr("data-image");
  var clickedPrice = $(".combo-list ." + name).attr("data-price");
  var clickedCompare = $(".combo-list ." + name).attr("data-compare");
  var clickedComparePercentage = $(".combo-list ." + name).attr(
    "data-compare-percentage",
  );
  //console.log('variant: '+clickedVariant);
  //console.log('variant: '+clickedPrice);
  var clickedVariant = $(".combo-list ." + name).attr("data-variant");

  if (!clickedVariant) {
      console.warn("No matching variant found for:", name);
      return;
  }

  window.history.replaceState(
      {},
      "",
      `${location.pathname}?variant=${clickedVariant}`
  );

  $("#currentSelection").attr("data-variant", clickedVariant);
  $("#currentSelection").attr("data-image", clickedImage);
  $("#currentSelection").attr("data-handle", name);
  $("#currentSelection").attr("data-price", clickedPrice);
  $("#currentSelection").attr("data-compare", clickedCompare);
  $("#compare_precntage, .comparetooltip").text(clickedComparePercentage);

  $(".product-single__thumbnails-items").removeClass("main active");
  $(".product-single__thumbnails-items." + name).addClass("main active");
  $(".product-single__thumbnails-items.main a").removeClass("active-thumb");
  $(".product-single__thumbnails-items." + name + " a").addClass(
    "active-thumb",
  );

  updateThumbnail();
  updateLinks();
  updatePrice();
}
/* FUNCTION FOR PRODUCT VARIANTS CUSTOM SELECTOR - a little bit more simplified combo selector that is reusable for products
File: product-form-customSelector.liquid
explanation of feature is found there as well
this will be the main custom selector from now on, and update, upgrade and extend this feature as needed
updated: 10-1-24
*/
jQuery(document).ready(function ($) {
  $(".color-box.show.initial").click();
  //console.log("default click initial color");
  setTimeout(function () {
    $(".color-box.initial").click();
    $(".color-box.show.initial").click();
  }, 1000);
  $(".type-box.initial").click();
  setTimeout(function () {
    $(".type-box.initial").click();
    $(
      ".with-overlay .product-single__thumbnails-items.thumb-overlay a",
    ).click();
  }, 900);
  $(".product-form .development").click(function () {
    alert(
      "this product is still in development and in its live testing phase and not yet for sale",
    );
  });
  updateAddonTopup();
  updateStockIndicator();
});

$(".ctm-type-selector .type-box:not(.disable)").click(function () {
  var selectedType = $(this).attr("data-type");
  var selectedTitle = $(this).attr("data-display");
  var currentColorT = $(".ctm-color-selector .initial-group")
    .text()
    .toLowerCase()
    .replace(/ /g, "-");
  var currentColor;
  if (currentColorT != "") {
    currentColor = currentColorT;
  } else {
    currentColor = $("#currentSelection")
      .attr("data-color")
      .toLowerCase()
      .replace(/ /g, "-");
  }
  $(".color-box").removeClass("show");
  $(".color-box[data-type = " + selectedType + "]").addClass("show");
  $(".type-box").removeClass("active");
  $(this).addClass("active");
  //$(".color-box.show.initial").click();
  $(".color-box.show.solo").click(); // don't comment out, this is needed for single colors like v-arm of door closer
  $(".color-box.show." + currentColor).click();

  $(".salebox-color").removeClass("active");
  $(".salebox-color." + currentColor).addClass("active");

  $(".ctm-type-selector .group-title span").text(selectedTitle);
  updateThumbnail();
  updateAddonTopup();
  updateGroupsellTopup();
  updateStockIndicator();
  $(".pdp-section.hideme").removeClass("active");
  $(".pdp-section." + selectedType).addClass("active");
});
$(".ctm-color-selector .color-box").click(function () {
  $(".color-box").removeClass("active");
  $(this).addClass("active");
  var currentColorT = $(this).attr("data-display");
  currentColorT = currentColorT.toLowerCase().replace(/ /g, "-");
  /* get variant id as reference */
  var selectedVariant = $(this).attr("data-id");
  var selectedTitle = $(this).attr("data-display");
  /* use variant id to match from combo-list */
  var selectedHandle = $("#" + selectedVariant).attr("data-handle");
  var clickedImage = $("#" + selectedVariant).attr("data-image");
  var clickedPrice = $("#" + selectedVariant).attr("data-price");
  var clickedCompare = $("#" + selectedVariant).attr("data-compare");
  var clickedAtcBtn = $("#" + selectedVariant).attr("data-atc");
  var clickedComparePercentage = $("#" + selectedVariant).attr(
    "data-compare-percentage",
  );
  var updateRestock = $("#" + selectedVariant).attr("data-restock");
  var clickedAddon = $("#" + selectedVariant).attr("data-addon-handle");
  var clickedAddonTopup = $("#" + selectedVariant).attr("data-addon-topup");
  var clickedBundles = $("#" + selectedVariant).attr(
    "data-bundled-variant-ids",
  );
  //console.log("bundles:" + clickedBundles);

  /* stock indicator for color selection */
  var stockIndicator = $("#" + selectedVariant).attr("data-stockIndicatorNum");
  var stockText = $("#" + selectedVariant).attr("data-restock");
  //console.log("stock-indicator:" + stockIndicator);
  $("#currentSelection").attr("data-stockNum", stockIndicator);
  $("#currentSelection").attr("data-restock", stockText);

  /* update current selection */
  $("#currentSelection").attr("data-variant", selectedVariant);
  $("#currentSelection").attr("data-handle", selectedHandle);
  $("#currentSelection").attr("data-color", selectedTitle);

  $("#currentSelection").attr("data-image", clickedImage);
  $("#currentSelection").attr("data-price", clickedPrice);
  $("#currentSelection").attr("data-compare", clickedCompare);

  $("#currentSelection").attr("data-addon-bundled", clickedAddon);
  /*if (location.pathname.indexOf("/prism-monsoon-dryer") > -1) {
    $("#currentSelection").attr("data-addon-topup", 'Up to $599');
  }else{
    $("#currentSelection").attr("data-addon-topup", clickedAddonTopup);
  }*/
  $("#currentSelection").attr("data-bundled-variant-ids", clickedBundles);

  $("#compare_precntage, .comparetooltip").text(clickedComparePercentage);
  /* update thumbs */
  $(".product-single__thumbnails-items").removeClass(" active");
  $(".product-single__thumbnails-items." + selectedHandle).addClass(" active");
  $(".product-single__thumbnails-items.main a").removeClass("active-thumb");
  $(".product-single__thumbnails-items." + selectedHandle + " a").addClass(
    "active-thumb",
  );
  /* for future if needed.. as of now, the blocks for multiple overlay is catered for sentinel bundle and the code is directly added there */
  var overlayBlock = $(".overlay-image.block-img");
  if (overlayBlock) {
    $(".overlay-image.block-img").removeClass("active");
    $(".overlay-image.block-img." + selectedHandle).addClass("active");
  }

  /* end for multiple overlay blocks */
  $(".ctm-color-selector .group-title span").text(selectedTitle);

  $(".salebox-color").removeClass("active");
  $(".salebox-color." + currentColorT).addClass("active");
  $(".product-form__checkout").text(clickedAtcBtn);
  updateAddonTopup();
  updateGroupsellTopup();
  addOnBundleSelector();
  updateThumbnail();
  updateLinks();
  updatePrice();
  updateVoucher();
  updateStockIndicator();

  const v_details = $(
    ".ProductSelect-product-template.hidden option[value=" +
      selectedVariant +
      "]",
  );

  if (v_details) {
    // 20250620 - update lead time by variant
    const restockText = v_details.attr("data-restock");
    if (restockText) {
      $(".product-restocks p b").html(restockText);
    } else {
      $(".product-restocks p b").text(updateRestock);
    }

    // 20250620 - hide pre-order text by variant
    if (v_details.attr("data-disable_stock_indicator")) {
      $(".pdp-review-stockcounter-wrapper .stock-wrap-nov2").hide();
    } else {
      $(".pdp-review-stockcounter-wrapper .stock-wrap-nov2").show();
    }
  }
});

$(".bundled-addon-selectors .select-wrapper .addon-box").click(function () {
  setTimeout(() => {
    $(".bundled-addon-selectors .click-plus").addClass("clicked testme");
  }, 100);
  $(".bundled-addon-selectors").addClass("selected selectme");
  var selectedType = $(this)
    .attr("data-display")
    .replace(/ *\([^)]*\) */g, "");
  var selectedType = selectedType.toLowerCase().replace(/ /g, "");
  //console.log(selectedType);
  //var selectedTitle = $(this).attr("data-display");
  $(".addon-box").removeClass("active");
  $(this).addClass("active");
  //$(this).parent().prev().find(".click-plus").click();

  /* get the main color */
  var getMainColor = $(".ctm-color-selector .group-title span")
    .text()
    .toLowerCase()
    .replace(/ /g, "-");
  //console.log(getMainColor);

  /* get the main type */
  var getMainType = $(".ctm-type-selector .type-box.active")
    .attr("data-type")
    .replace(/ *\([^)]*\) */g, "");
  var getMainType = getMainType.toLowerCase().replace(/ /g, "-");
  //console.log(getMainType);
  /* get the extra */
  var getExtraHandle = $(".bundled-addon-selectors .select-wrapper").attr(
    "data-extra-handle",
  );
  /* add them all together */
  if (location.pathname.indexOf("/prism-cyclone-dryer") > -1) {
    var getMainColor2 = "matte-black";
  } else {
    var getMainColor2 = getMainColor;
  }
  let bundleHandleAddon = `${selectedType}-${getMainColor}-${getMainType}-${getMainColor}-${getExtraHandle}-${getMainColor2}`;

  if (location.pathname.indexOf("/prism-monsoon-washer") > -1) {
    bundleHandleAddon = `${getMainType}-${getMainColor}-${selectedType}-${getMainColor}-${getExtraHandle}-${getMainColor}`;

  }
  if (location.pathname.indexOf("/prism-cyclone-washer") > -1) {
    var getMainColor2 = "matte-black";
    bundleHandleAddon = `${getMainType}-${getMainColor}-${selectedType}-${getMainColor}-${getExtraHandle}-${getMainColor2}`;

  }

  $("#currentSelection").attr("data-addon-bundled", bundleHandleAddon);

  updateLinks();
});

// #region door selector
$(".laminate-selector select").on("change", function () {
  const variant = $(`#${$(this).val()}`);
  const door_3x7_url = variant.attr("data-image_3x7_door");
  const door_4x7_url = variant.attr("data-image_4x7_door");

  const selectedSize = $(
    ".door-selector[data-option='size'] .item.active",
  ).attr("data-door_size");
  if (selectedSize == "3ftx7ft-single-leaf") {
    updateImage(door_3x7_url);
  } else if (selectedSize == "4ftx7ft-double-leaf") {
    updateImage(door_4x7_url);
  }

  function updateImage(imgUrl) {
    const thumbnail = $(
      ".product-single__thumbnails .product-single__thumbnail",
    ).first();
    const thumbnailImg = thumbnail.find("img");
    thumbnail.attr("href", imgUrl);
    thumbnail.attr("data-zoom", imgUrl);
    thumbnail.data("zoom", imgUrl);
    thumbnailImg.attr("src", imgUrl);
    thumbnail.data("src", imgUrl);
    thumbnail.click();

    const desktopImg = $(".product-single__photo.desktop_photo");
    desktopImg.attr("data-zoom", imgUrl);
    desktopImg.data("zoom", imgUrl);
    desktopImg.find(".product-featured-img").attr("data-src", imgUrl);
    desktopImg.find(".product-featured-img").data("src", imgUrl);

    const mobileImgOwl = $(
      ".product_photo_container .owl-item:nth-child(3), .product_photo_container .owl-item:nth-child(6)",
    );
    mobileImgOwl.find(".product-single__photo").attr("data-zoom", imgUrl);
    mobileImgOwl.find(".product-single__photo").data("zoom", imgUrl);
    mobileImgOwl.find(".product-single__photo img").attr("src", imgUrl);
    mobileImgOwl.find(".product-single__photo img").attr("data-src", imgUrl);
    mobileImgOwl.find(".product-single__photo img").data("src", imgUrl);
  }
});
$(".door-selector .item").on("click", function () {
  const selectorWrapper = $(this).closest(".product-selector-wrapper");
  const option = selectorWrapper.attr("data-option");
  const groupId = $(this).attr("data-group_id");
  const fireRating = $(this).attr("data-fire_rating");
  const variant = $(this).attr("data-variant");

  const doorSelector = $(".door-selector");
  const doorTypeSelector = $(".door-selector[data-option='door-type']");
  const fireRatingSelector = $(".door-selector[data-option='fire-rating']");
  const sizeSelector = $(".door-selector[data-option='size']");

  function updateDoorSelectorDisplay(
    door_type,
    fire_rating = "30",
    variant = null,
  ) {
    doorSelector.find(".item").removeClass("active");
    sizeSelector.find(".item").addClass("hide");

    doorTypeSelector
      .find(`.item[data-group_id='${door_type}']`)
      .addClass("active");

    if (door_type == "swd") {
      fireRatingSelector.addClass("hide");
      sizeSelector.find(".item[data-group_id='swd']").removeClass("hide");
      sizeSelector.find(".item[data-group_id='swd']").removeClass("hide");
    } else if (door_type == "frd") {
      fireRatingSelector.removeClass("hide");
      fireRatingSelector
        .find(`.item[data-fire_rating='${fire_rating}']`)
        .addClass("active");
      sizeSelector
        .find(`.item[data-group_id='frd'][data-fire_rating='${fire_rating}']`)
        .removeClass("hide");
    }

    handleSizeSelector(variant);
  }

  function handleSizeSelector(variant = null) {
    sizeSelector.find(".item").removeClass("active");

    const v =
      variant ||
      sizeSelector.find(".item:not(.hide)").first().attr("data-variant");
    sizeSelector.find(`.item[data-variant='${v}']`).addClass("active");

    $(".laminate-selector select").trigger("change");

    /* update current selection */
    const selectedVariant = $(`#${v}`);
    $("#currentSelection").attr(
      "data-variant",
      selectedVariant.attr("data-variant"),
    );
    $("#currentSelection").attr(
      "data-handle",
      selectedVariant.attr("data-handle"),
    );

    $("#currentSelection").attr(
      "data-image",
      selectedVariant.attr("data-image"),
    );
    $("#currentSelection").attr(
      "data-price",
      selectedVariant.attr("data-price"),
    );
    $("#currentSelection").attr(
      "data-compare",
      selectedVariant.attr("data-compare"),
    );

    updateThumbnail();
    updateLinks();
    updatePrice();
    updateInstallment();
  }

  switch (option) {
    case "door-type":
      updateDoorSelectorDisplay(groupId);
      break;

    case "fire-rating":
      updateDoorSelectorDisplay(groupId, fireRating);
      break;

    case "size":
      handleSizeSelector(variant);
      break;
  }
});
$(
  ".door_mortice_set-selector .item, .door_peephole_viewer-selector .item, .door_closer-selector .item",
).on("click", function () {
  $(this).siblings(".item").removeClass("active");
  $(this).addClass("active");
});
// handle extended warranty
$("#product-doors-8851863929059 .groupsell-wrap-second input").on(
  "change",
  function () {
    if ($(this).is(":checked")) {
      $(".addon_by_variants-container").removeClass("hide");
    } else {
      $(".addon_by_variants-container").addClass("hide");
    }
    const selectedVariantId = $(this).val();
    const addons = $(".addon_by_variants-container .addon");
    addons.addClass("hide");
    addons.each(function () {
      const mainVariantIds = $(this).attr("data-main-product-variant-ids");
      if (mainVariantIds != null) {
        const mainVariantIdsList = mainVariantIds
          .split(",")
          .map((x) => x.trim());

        if (mainVariantIdsList.includes(selectedVariantId)) {
          $(this).removeClass("hide");
        }
      }
    });
  },
);
jQuery(document).ready(function ($) {
  if (!$("#product-doors-8851863929059").length) return;

  $(".laminate-selector select").select2({
    minimumResultsForSearch: Infinity,
  });
  $(".door-selector[data-option='size'] .item.active").trigger("click");
  tippy(".tooltip-door-type", {
    content:
      "Solid Wood: Solid Wood Core<br>Fire Rated: Insulated Core<br><br>If your existing door is fire rated, it must be replaced with a fire rated door to comply with SCDF requirements",
    allowHTML: true,
    placement: "bottom",
    theme: "light",
  });
  $(".addon_by_variants-container").addClass("hide");
});
// #endregion

// #region gate selector
const gateImageCache = {};
async function handleGateColourDynamicImages() {
  function updateImage(imgUrl) {
    const thumbnail = $(
      ".product-single__thumbnails .product-single__thumbnails-items:not(.hide) .product-single__thumbnail",
    ).first();
    const thumbnailImg = thumbnail.find("img");
    thumbnail.attr("href", imgUrl);
    thumbnail.attr("data-zoom", imgUrl);
    thumbnail.data("zoom", imgUrl);
    thumbnailImg.attr("src", imgUrl);
    thumbnail.data("src", imgUrl);
    thumbnail.click();

    const desktopImg = $(".product-single__photo.desktop_photo");
    desktopImg.attr("data-zoom", imgUrl);
    desktopImg.data("zoom", imgUrl);
    desktopImg.find(".product-featured-img").attr("data-src", imgUrl);
    desktopImg.find(".product-featured-img").data("src", imgUrl);

    const mobileImgOwl = $(
      ".product_photo_container .owl-item:nth-child(3), .product_photo_container .owl-item:nth-child(6)",
    );
    mobileImgOwl.find(".product-single__photo").attr("data-zoom", imgUrl);
    mobileImgOwl.find(".product-single__photo").data("zoom", imgUrl);
    mobileImgOwl.find(".product-single__photo img").attr("src", imgUrl);
    mobileImgOwl.find(".product-single__photo img").attr("data-src", imgUrl);
    mobileImgOwl.find(".product-single__photo img").data("src", imgUrl);
  }

  function loadImage(gateDesignColour, callback) {
    if (gateImageCache[gateDesignColour]) {
      callback(gateImageCache[gateDesignColour]);
      return;
    }

    const baseUrl = "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/";
    const imageUrl = `${baseUrl}${gateDesignColour}.jpg`;
    const fallbackUrl = `${baseUrl}${gateDesignColour.split("-")[0]}.jpg`;

    const loadAndCache = (url) => {
      const img = new Image();
      img.onload = function () {
        gateImageCache[gateDesignColour] = url;
        callback(url);
      };
      img.onerror = function () {
        if (url !== fallbackUrl) {
          loadAndCache(fallbackUrl);
        } else {
          console.error("Failed to load image:", url);
          callback(null);
        }
      };
      img.src = url;
    };

    loadAndCache(imageUrl);
  }

  const design = $(
    "[data-option='design'] select:not(.hide) option:selected",
  ).text();
  const colour = $("[data-option='gate-colours'] li.active")
    .attr("data-title")
    .replaceAll(" ", "");
  loadImage(
    colour == "SatinBlack" ? design : `${design}-${colour}`,
    (loadedUrl) => {
      if (loadedUrl) {
        updateImage(loadedUrl);
      }
    },
  );
}
$(".gate-selector[data-option='design'] select").on("change", function () {
  const variant = $(`#${$(this).val()}`);
  if (!variant) return;

  const price = variant.attr("data-price") || 0;
  const compareAtPrice = variant.attr("data-compare") || 0;
  const isLaminateSeries =
    $(".gate-selector[data-option='type'] .item.active").attr(
      "data-gate_type",
    ) == "laminate_series";

  // handle desktop thumbnail
  if (isLaminateSeries) {
    $(
      `#product-gates-8855634280675 .thumb-wrapper .product-single__thumbnails-items:has(a[href*='Laminate'])`,
    ).removeClass("hide");
  } else {
    $(
      `#product-gates-8855634280675 .thumb-wrapper .product-single__thumbnails-items:has(a[href*='Laminate'])`,
    ).addClass("hide");
  }

  $("#currentSelection").attr("data-price", price);
  $("#currentSelection").attr("data-compare", compareAtPrice);
  updatePrice();
  updateVoucher();
  handleGateColourDynamicImages();
});
$(".gate-selector .item").on("click", function () {
  const selectorWrapper = $(this).closest(".product-selector-wrapper");
  const option = selectorWrapper.attr("data-option");

  $(this).siblings(".item").removeClass("active");
  $(this).addClass("active");

  const sizeOption = $(".gate-selector[data-option='size']");
  const designOption = $(".gate-selector[data-option='design']");
  const laminateOption = $(".gate-selector[data-option='laminate']");

  let gateType = null;
  let gateSize = null;

  if (option == "type") {
    const sizeOptionItems = sizeOption.find(".item");
    sizeOptionItems.removeClass("active");
    sizeOptionItems.addClass("hide");

    gateType = $(this).attr("data-gate_type");
    const gateTypeSize = sizeOption.find(`.item[data-gate_type='${gateType}']`);
    gateTypeSize.removeClass("hide");
    gateTypeSize.first().addClass("active");

    gateSize = gateTypeSize.first().attr("data-gate_size");

    if (gateType == "laminate_series") {
      laminateOption.removeClass("hide");
      $("[data-option='gate-plate'] .item").removeClass("active");
      $("[data-option='gate-plate'] .item").first().addClass("active");
      $(
        "[data-option='gate-plate'] .item[data-variant='46369809498339']",
      ).addClass("hide");
    } else {
      laminateOption.addClass("hide");
      $(
        "[data-option='gate-plate'] .item[data-variant='46369809498339']",
      ).removeClass("hide");
    }
  } else if (option == "size") {
    gateType = $(this).attr("data-gate_type");
    gateSize = $(this).attr("data-gate_size");
  } else if (option == "gate-colours") {
    selectorWrapper.find(".initial-group").text($(this).attr("data-title"));
    handleGateColourDynamicImages();
  }

  if (gateType != null && gateSize != null) {
    const designOptionSelects = designOption.find("select");
    designOptionSelects.addClass("hide");

    const select = designOption.find(
      `select[data-gate_type='${gateType}'][data-gate_size='${gateSize}']`,
    );

    select.removeClass("hide");
    select.trigger("change");
  }
});
// handle extended warranty
$("#product-gates-8855634280675 .groupsell-wrap-second input").on(
  "change",
  function () {
    if ($(this).is(":checked")) {
      $(".addon_by_variants-container").removeClass("hide");
    } else {
      $(".addon_by_variants-container").addClass("hide");
    }
    const selectedVariantId = $(this).val();
    const addons = $(".addon_by_variants-container .addon");
    addons.addClass("hide");
    addons.each(function () {
      const mainVariantIds = $(this).attr("data-main-product-variant-ids");
      if (mainVariantIds != null) {
        const mainVariantIdsList = mainVariantIds
          .split(",")
          .map((x) => x.trim());

        if (mainVariantIdsList.includes(selectedVariantId)) {
          $(this).removeClass("hide");
        }
      }
    });
  },
);
jQuery(document).ready(function ($) {
  if (!$("#product-gates-8855634280675").length) return;

  $(".gate-selector[data-option='design'] select").select2({
    minimumResultsForSearch: Infinity,
  });
  $(".gate-selector[data-option='laminate'] select").select2({
    minimumResultsForSearch: Infinity,
  });
  $(
    "#product-gates-8855634280675 .thumb-wrapper .product-single__thumbnails-items:not(:first-child)",
  ).addClass("hide");
  $(".gate-selector[data-option='design'] select:not(.hide)").trigger("change");
  (() => {
    const owl = $(".product_photo_container .owl-carousel");
    const owlItems = owl.find(".owl-item:not(.cloned)");
    const totalItems = owlItems.length;
    for (let i = totalItems - 3; i >= 1; i--) {
      owl.trigger("remove.owl.carousel", [i]).trigger("refresh.owl.carousel");
    }
  })();
  $(".addon_by_variants-container").addClass("hide");
});
$(document).ready(function () {
  var $overlays = $(".overlay-image.block-image");
  var $thumbnails = $(".product-single__thumbnails-items a");

  if ($overlays.length && $thumbnails.length) {
    $thumbnails.on("click", function () {
      var $parentLi = $(this).closest(".product-single__thumbnails-items");

      if ($parentLi.hasClass("hide-overlay")) {
        // hide all overlays
        $overlays.hide();
      } else {
        // hide all first
        $overlays.hide();

        // show only the last active overlay
        var $activeOverlay = $overlays.filter(".active").last();
        if ($activeOverlay.length) {
          $activeOverlay.show();
        }
      }
    });
  }
});

// #endregion

/* overlay products feature */
$(".overlay-selector .color-box").click(function () {
  $(this).siblings().removeClass("active");
  $(this).addClass("active");

  /* get variant id as reference */
  var selectedVariant = $(this).attr("data-id");
  var selectedTitle = $(this).attr("data-display");
  var selectedImage = $(this).attr("data-image");
  var selectedType = $(this).attr("data-type");
  var selectedColor = $(this).attr("data-color");

  /* update current selection */
  //$(".grid__item.product-single__photos").append("<img src='" + selectedImage + "'/>");
  $(".with-overlay .overlay-images." + selectedType).removeClass("active");
  $(
    ".with-overlay .overlay-images." + selectedType + "-" + selectedColor,
  ).addClass("active");
  console.log("selected title: " + selectedTitle);
  $(this).parent().parent().parent().siblings().children().text(selectedTitle);
  //.find(".overlay-selector .group-title span")
  //.text(selectedTitle);
  overlayGroupItems();
  updateStockIndicator();
});

$(".with-overlay .product-single__thumbnails-items a").click(function () {
  $(".assoc-variants-images").removeClass("active");
  $(".product-single__photo").removeClass("hidden2");
});

$(".with-overlay .product-single__thumbnails-items.thumb-overlay a").click(
  function () {
    $(".assoc-variants-images").addClass("active");
    $(".product-single__photo").addClass("hidden2");
  },
);
function overlayGroupItems() {
  const overlayitems = [];
  const selection = [];
  $(".overlay-selector .color-box.active").each(function () {
    var item = $(this).attr("data-id");
    overlayitems.push(item);

    var itemType = $(this).attr("data-type").replace("-", " ");
    var itemColor = $(this).attr("data-color").replace("-", " ");
    var itemSelection = itemType + ":" + itemColor;
    selection.push(itemSelection);
  });
  var myselVariant = $("#currentSelection").attr("data-variant");
  clickedComparePercentage = $("option[value= " + myselVariant + "]").attr(
    "data-compare-percentage",
  );
  $("#compare_precntage, .comparetooltip").text(clickedComparePercentage);
  console.log(myselVariant);
  console.log(clickedComparePercentage);
  var overlayBundles = overlayitems.toString();
  var overlaySelection = selection.toString();
  //console.log(overlayBundles);
  $("#currentSelection").attr("data-properties", overlaySelection);
  $(".product-form__variants2 option").attr(
    "data-bundled-variant-ids",
    overlayBundles,
  );
  $(".product-single__photo").addClass("hidden2");
  $(".assoc-variants-images").addClass("active");
}
/* end of overlay feature */
function addOnBundleSelector() {
  /* if bundle groupsell is selected, and customer clicks on color selector */

  if ($(".bundled-addon-selectors.selected").hasClass("selected")) {
    console.log("load bundle selector function");
    /* get current ones */
    var selectedType = $(".bundled-addon-selectors .addon-box.active")
      .attr("data-display")
      .replace(/ *\([^)]*\) */g, "");
    var selectedType = selectedType.toLowerCase().replace(/ /g, "");

    /* get the main color */
    var getMainColor = $(".ctm-color-selector .group-title span")
      .text()
      .toLowerCase()
      .replace(/ /g, "-");
    //console.log(getMainColor);

    /* get the main type */
    var getMainType = $(".ctm-type-selector .type-box.active")
      .attr("data-type")
      .replace(/ *\([^)]*\) */g, "");
    var getMainType = getMainType.toLowerCase().replace(/ /g, "-");
    //console.log(getMainType);
    /* get the extra */
    var getExtraHandle = $(".bundled-addon-selectors .select-wrapper").attr(
      "data-extra-handle",
    );
    /* add them all together */
    if (location.pathname.indexOf("/prism-cyclone-dryer") > -1) {
      var getMainColor2 = "space-grey";
    } else {
      var getMainColor2 = getMainColor;
    }
    let bundleHandleAddon = `${selectedType}-${getMainColor}-${getMainType}-${getMainColor}-${getExtraHandle}-${getMainColor2}`;
    if (location.pathname.indexOf("/prism-monsoon-washer") > -1) {
      bundleHandleAddon = `${getMainType}-${getMainColor}-${selectedType}-${getMainColor}-${getExtraHandle}-${getMainColor}`;

    }
    if (location.pathname.indexOf("/prism-cyclone-washer") > -1) {
      var getMainColor2 = "space-grey";
      bundleHandleAddon = `${getMainType}-${getMainColor}-${selectedType}-${getMainColor}-${getExtraHandle}-${getMainColor}`;

    }
    console.log('addon selected, need to update bundle');
    $("#currentSelection").attr("data-addon-bundled", bundleHandleAddon);
  } else {
  }
}
function addOnBundle() {
  /* CUSTOM SCRIPT FOR BUNDLED ADD-ONS 
  if groupsell is used with type selector and color selector blocks
  */
  /* WASHER / DRYER CUSTOM ADD-ONS for now, but can be used by others
  * on select of main product selector, select the same color from the bundle 
  go to metafields, add the the main product, set variants to have custom.addon_bundle with values that corresponds to the handle of the bundled product
  */

  /* check if it bundled-addon has class and if selected */
  if ($(".bundled-addon").hasClass("selected")) {
    /* get bundle handle from currentSelection */
    var currentBundleHandle = $("#currentSelection").attr("data-addon-bundled");
    console.log("current handle: " + currentBundleHandle);
    var bundledVariant = $(".variant." + currentBundleHandle).attr(
      "data-variant",
    );
    /* set new curent selection */
    $("#currentSelection").attr("data-variant", bundledVariant);
    console.log("fn1:" + currentBundleHandle);
  } else {
    // check if groupsell has bundled selectors and reset
    var bundleAddon = $("#currentSelection").attr("data-addon-bundled");
    if (bundleAddon) {
      var handle = $("#currentSelection").attr("data-handle");
      var liMatch = document.querySelector(
        `.combo-list li[data-handle="${handle}"]`,
      );

      if (liMatch) {
        var oldVariantID = liMatch.dataset.variant; // SAFE
        $("#currentSelection").attr("data-variant", oldVariantID);
        //console.log("Found variant via <li>: ", oldVariantID);
      } else {
        //console.log("No LI match for handle:", handle);
      }
    }
  }
  if ($(".bundled-addon-selectors").hasClass("selected")) {

    /* get bundle handle from currentSelection */
    var currentBundleHandle = $("#currentSelection").attr("data-addon-bundled");

    var bundledVariant = $(".variant." + currentBundleHandle).attr(
      "data-variant",
    );

    /* update data topup via addon-box */
    /* update top-up via calculation */
    var $bundle = $(".variant." + currentBundleHandle);

    var bundledVariant = $bundle.attr("data-variant");

    // Prices
    var bundlePrice = Number(
        String($bundle.attr("data-addon-price") || 0).replace(/,/g, "")
    );

    var productPrice = Number(
        String($("#currentSelection").attr("data-price") || 0)
            .replace(/,/g, "")
            .replace(".00", "")
    );

    var topup = bundlePrice - productPrice;

    
    // Update current selection
    $("#currentSelection")
        .attr("data-addon-topup", topup);

    /* set new curent selection */
    $("#currentSelection").attr("data-variant", bundledVariant);
    updateGroupsellTopup();
  }
}
function resetBundleInitial() {
  console.log("Resetting bundle initial...");

  /* if groupsell is unclicked, click on current active selections */
  if ($(".bundled-addon").hasClass("selected")) {
    /* bundle groupsell is selected, do nothing */
  } else {
    $(".type-box.active").click();
    $(".color-box.show.active").click();
    $(".addon-box").removeClass("active");
  }
}
// ========================================================
// Update Topup for bundled topup
// ========================================================
function updateAddonTopup() {
    // Selected Groupsell variant
    var variantId = $(".bundled-addon-selectors input[name='bundle_prod']").val();
    if (!variantId) return;
    // Find matching combo
    var $combo = $(".bundled-addon-selectors .combo-list li[data-variant='" + variantId + "']");
    if (!$combo.length) return;

    var addonPrice = Number(
        String($combo.attr("data-addon-price") || 0).replace(/,/g, "")
    );
    var productPrice = Number(
        String($("#currentSelection").attr("data-price") || 0).replace(/,/g, "")
    );

    var topup = addonPrice - productPrice;

    $("#currentSelection").attr("data-addon-topup", topup);
}
function updateGroupsellTopup() {
  var rawTopup = $("#currentSelection").attr("data-addon-topup");

  // Do nothing if no top-up has been set yet
  if (!rawTopup) return;

  var currentGroupsellTopup = Number(
    String(rawTopup).replace(/,/g, "")
  );

  var display = "$" + currentGroupsellTopup.toLocaleString("en-US");

  $(".groupsell-addon-topup").text(display);
  $(".groupsell-addon-topup-main").text(display);
}
/* end of PRODUCT VARIANTS CUSTOM SELECTOR */

/* =============================================
FUNCTION FOR GROUP PRODUCT VARIANTS
============================================= */
/* change selected group */
$(".product-group-variants .box-title").click(function () {
  $(".product-group-variants .box-title").removeClass("active");
  $(this).addClass("active");

  var group_handle = $(this).attr("data-title");
  var stockNum = $(this).attr("data-stockNum");
  var restock = $(this).attr("data-restock");
  $(".product-group-variants .group-selector").removeClass("active");
  $(".product-group-variants .group-selector." + group_handle).addClass(
    "active",
  );
  // 🔥 NEW: Disclaimer logic
  var disclaimerText = $(this).attr("data-disclaimer");
  var disclaimerBox = $(".product-group-variants .disclaimer");

  if (disclaimerText && disclaimerText.trim() !== "") {
    disclaimerBox.text(disclaimerText).show();
  } else {
    disclaimerBox.text("").hide();
  }
  console.log('GROUP SELECTOR'+stockNum);
  $('#currentSelection').attr('data-stocknum', stockNum);
  $('#currentSelection').attr('data-restock', restock);


  $(".product-group-variants .group-selector.active li").first().click();
  $(".product-group-variants .group-selector.active li.always-show").click();
  data_display();
  updateStockIndicator();
  updateThumbnail();
  groupsellVariantShow();
});
function data_display() {
  var active_one = $(
    ".product-group-variants .product-selector .box-title.active",
  ).attr("data-display");
  var active_two = $(
    ".product-group-variants .group-selector.active .variant-item.active",
  ).attr("data-display");

  $(".group-title .initial-group").text(active_one);
  $(".group-selector .variant-group").text(active_two);
}
/* function for groupsell items with variants */
$(".groupsell-variant .colorbox-select2 li").click(function () {
  $(".groupsell-variant .selected .colorbox-select2 li").removeClass("active");
  $(this).addClass("active");
  var groupsell_selected_variant = $(this).attr("data-id");
  var groupsell_selected_title = $(
    ".groupsell-variant .newsalebox2.selected .colorbox-select2 li.active",
  ).attr("display-title");
  var groupsell_selected_image = $(this).attr("data-image");
  $(".selectedgroupsell").text(groupsell_selected_variant);
  updateLinks();

  $(".groupsell-variant .newsalebox2.selected .popimg img").attr(
    "src",
    groupsell_selected_image,
  );
  $(".selected .variant-groupsell-selected").text(groupsell_selected_title);

  const isGroupsellSecond =
    $(this).closest(".groupsell-wrap-second").length > 0;
  if (isGroupsellSecond) {
    const groupsell_wrap = $(this).closest(".groupsell-wrap");
    // hide all prices (& voucher)
    groupsell_wrap
      .find(".oldPrice2, .newprice, .voucher-pricing")
      .addClass("hide");

    // display correct price (& voucher)
    groupsell_wrap
      .find(
        `.oldPrice2[data-variant-compare-at-prices="${groupsell_selected_variant}"], .newprice[data-variant-prices="${groupsell_selected_variant}"], .voucher-pricing[data-variant="${groupsell_selected_variant}"]`,
      )
      .removeClass("hide");
  }

  const input = $(this)
    .closest(".newsalebox2")
    .find("input[name='bundle_prod_2']");
  input.val(groupsell_selected_variant);
  input.trigger("change");
});

function groupsel_variant_initial() {
  $(".groupsell-variant .colorbox-select2 li:first-of-type").addClass("active");
  var groupsell_selected_title = $(
    ".groupsell-variant .newsalebox2 .colorbox-select2 li.active",
  ).attr("display-title");
  $(".variant-groupsell-selected").text(groupsell_selected_title);
}
function groupsell_variant_select() {
  var groupsell_selected_variant = $(
    ".groupsell-variant .newsalebox2.selected .colorbox-select2 li.active",
  ).attr("data-id");
  $(".selectedgroupsell").text(groupsell_selected_variant);
}

/* for custom block specific for sentinel - sentry bundles
file: product-form-sentinel-bundle
*/
/* set initials */
$(window).on("load", function () {
  setTimeout(() => {
    $(".simple-selector .box-title.initial").trigger("click");

    //updateThumbnail();
  }, 300);

  $(".sentinel-color-selector .initial").trigger("click");

  groupsellVariantShow();
  var urlString = document.referrer;
  if (urlString != "") {
    collectionSelection();
  }
  /*else{
    variantPreSelection();
  }*/
});
$(".sentinel-selector-wrapper .colorbox-select li").click(function () {
  $(".sentinel-selector-wrapper .colorbox-select li").removeClass("active");
  $(this).addClass("active");
  var prod_handle = $(this).attr("data-handle");
  var display_title = $(this).attr("display-title");

  $(".sentinel-selected").text(prod_handle);
  $(".variant-select .variant-sentinel-bundle ").text(display_title);

  setSentinelBundle();
});
$(".sentry-selector-wrapper .colorbox-select li").click(function () {
  $(".sentry-selector-wrapper .colorbox-select li").removeClass("active");
  $(this).addClass("active");
  var prod_handle = $(this).attr("data-handle");
  var display_title = $(this).attr("display-title");

  $(".sentry-color-selected").text(prod_handle);
  $(".variant-select .variant-sentry-bundle ").text(display_title);
  setSentinelBundle();
});

$(".sentry-selector-wrapper .box-title").click(function () {

  if ($(this).hasClass("prism-sentry-smart-gate-lock")) {
        
    }
    setSentinelBundle();
    if ($(this).hasClass("sentry-pro")) {
        $(".variant-nickel-silver").hide();
        $(".variant-sentry-pro-copper-rose").show();
        $(".variant-copper-rose").click();
    } else if ($(this).hasClass("sentry")) {
        $(".variant-nickel-silver").show();
        $(".variant-sentry-pro-copper-rose").hide();
        $(".variant-item.initial.variant-nickel-silver").trigger("click");
    }

});
$(".sentinel-sentry-bundle-selector .bundle-title").click(function () {
  $(".sentinel-sentry-bundle-selector .bundle-title").removeClass("active");
  $(this).addClass("active");
  setSentinelBundle();
});
function setSentinelBundle() {
  var selected_sentinel = $(".sentinel-selected").text();
  if (!selected_sentinel) return;
  var selected_sentry = $(".sentry-selector-wrapper .initial-group")
    .text()
    .toLowerCase()
    .replace(/ /g, "-");
  var selected_sentry_color = $(".sentry-color-selected").text();
  if (!selected_sentry_color) return;
  var selected_bundle =
    selected_sentinel + "-" + selected_sentry + "-" + selected_sentry_color;
  
  if (selected_sentry == "sentry-pro") {
    $(".variant-copper-rose").show();
    //$(".variant-copper-rose").addClass('active');
    //$("#currentSelection").attr("data-variant", '48554692837603');

  } else if (selected_sentry == "sentry") {
    $(".variant-copper-rose").hide();
    $(".variant-copper-rose").removeClass('active');
    $(".variant-nickel-silver").show();
    $(".variant-nickel-silver").addClass('active');
  }
  

  if ($(".sentinel-sentry-bundle-selector .saver-bundle").hasClass("active")) {
    var saverTrue = true;
    var selected_bundle =
      selected_sentinel +
      "-" +
      selected_sentry +
      "-" +
      selected_sentry_color +
      "-saver";
  } else {
    var selected_bundle =
      selected_sentinel + "-" + selected_sentry + "-" + selected_sentry_color;
  }

  $(".overlay-image.block-img").removeClass("active");
  $(".overlay-image.block-img." + selected_bundle).addClass("active");

  console.log("selected-sentinel" + selected_sentinel);
  $(".selected-bundle-handle").text(selected_bundle);

  /* get and display necessary info 
  var clickedImage = $(".combo-list #"+selected_bundle).attr("data-image");
  $('.product-single__photo .product-featured-img').attr('src', clickedImage);
  */
  $(".product-single__thumbnails-items").removeClass("active");

  $(".product-single__thumbnails-items.main a").removeClass("active-thumb");
  $(".product-single__thumbnails-items." + selected_bundle).addClass("active");

  $(".product-single__thumbnails-items.thumb-show-always").addClass("active");
  $(
    ".product-single__thumbnails-items.main." + selected_bundle + " a",
  ).addClass("active-thumb");

  var clickedVariantID = $(".combo-list #" + selected_bundle).attr(
    "data-variant",
  );
  var clickedPrice = $(".combo-list #" + selected_bundle).attr("data-price");
  var clickedCompare = $(".combo-list #" + selected_bundle).attr(
    "data-compare",
  );
  var clickedVoucher = $(".combo-list #" + selected_bundle).attr(
    "data-voucher",
  );
  var clickedVoucherText = $(".combo-list #" + selected_bundle).attr(
    "data-voucherText",
  );
  var clickedAtc = $(".combo-list #" + selected_bundle).attr("data-atc");
  /* manual compute since saver and standard are not saved in data attrib 
  var clickedComparePercentage = $(".combo-list #" + selected_bundle).attr(
    "data-compare-percentage"
  );
  */
  myInteger = parseInt(clickedCompare.replace(/\,/g, ""));
  myPrice = parseInt(clickedPrice.replace(/\,/g, ""));
  varPrice = myPrice - clickedVoucher;
  var clickedComparePercentage =
    Math.round(((myInteger - varPrice) / myInteger) * 100) + "%";
  $("#compare_precntage, .comparetooltip").text(clickedComparePercentage);
  $("#currentSelection").attr("data-variant", clickedVariantID);
  $("#currentSelection").attr("data-price", clickedPrice);
  $("#currentSelection").attr("data-compare", clickedCompare);
  $("#currentSelection").attr("data-voucher", clickedVoucher);
  $("#currentSelection").attr("data-voucherText", clickedVoucherText);
  $("a#initateCheckout").text(clickedAtc);

  /* sentinel bundle voucher quickfix */
  if (typeof saverTrue !== "undefined" && saverTrue) {
    $("#prism-sentinel-pro-2024-bundles-9204349108451 #currentSelection").attr(
      "data-voucher",
      "250",
    );
    $("#prism-sentinel-pro-2024-bundles-9204349108451 .dynamicCode").text("LOCK250");
  } else {
    $("#prism-sentinel-pro-2024-bundles-9204349108451 #currentSelection").attr(
      "data-voucher",
      "300",
    );
    $("#prism-sentinel-pro-2024-bundles-9204349108451 .dynamicCode").text("LOCK300");
  }
  


  updateLinks();
  updatePrice();
  updateVoucher();
  updateThumbnail();
}
function groupsellVariantShow() {
  var activeBox = $(".box-title.active")
    .attr("data-display")
    ?.replace(/ /g, "")
    .toLowerCase();
  $(
    ".groupsell-variant.groupsell-variant-hide, .groupsell-variant .groupsell-salebox-hide",
  ).removeClass("active");
  $(".groupsell-variant.groupsell-variant-hide." + activeBox).addClass(
    "active",
  );
  $(".groupsell-variant .groupsell-salebox-hide." + activeBox).addClass(
    "active",
  );
  $(".groupsell-variant .newsalebox2").removeClass("selected");
  $(".selectedgroupsell").text("");
}
function collectionSelection() {
  /* set initial variants when selected from the collection page */

  var urlString2 = document.referrer;
  var urlString = window.location.href;
  var referred = localStorage.getItem("referred");
  var variantSelected = localStorage.getItem("prodType");

  if (referred) {
    var urlMain = urlString2;
  } else {
    var urlMain = urlString;
  }
  console.log("url: " + urlMain);
  if (urlMain.indexOf("prismplus") > -1) {
    /* if inside prism */
    if (urlMain.indexOf("variant") > -1) {
      /* if has variant, this means that there was a selection done between the options */
      /* if there was a selection, the localStorage got updated */
      var variantSelectedOption = variantSelected;
      var paramString =
        urlString.split("?")[0]; /* split the variant part to remove*/

      if (variantSelectedOption) {
        $(
          ".box-title." +
            variantSelectedOption
              .replace(/ /g, "-")
              .replace("+", "")
              .toLowerCase(),
        ).trigger("click");
        console.log(
          "variantSelected:" +
            variantSelectedOption
              .replace(/ /g, "-")
              .replace("+", "")
              .toLowerCase(),
        );
      }
    }
  } //outside prism, do nothing

  /* One-shot flags owned by this script only.
    NEVER use localStorage.clear() here — it wipes every key on the origin
    (Google Ads _gcl_ls, Klaviyo, Judge.me, discount app, recently-viewed…). */
  try {
    localStorage.removeItem("referred");
    localStorage.removeItem("prodType");
  } catch (e) {
    /* storage blocked (Safari private mode / ITP) */
  }
}
function variantPreSelection() {
  /* load defaults based on url using variant id
  then preselect colors based on variant id */
  /* get variantID */
  console.log("pre-select");
  var urlString = window.location.href;
  var variantString = urlString.split("?variant=")[1];

  /* since the bundle is based on the handle, need to get handle on combo list based from the taken variantID 
  if(variantString){
    var selected_bundle = $(
      ".ProductSelect-product-template option[value= " + variantString + "]"
    ).attr("data-handle");
    //$('.selected-bundle-handle').text(selected_bundle);
    updateSentinelBundle();
  }
  */
}
function updateStockIndicator() {
  var stockNum = $("#currentSelection").attr("data-stocknum");
  //var restockText = $("#currentSelection").attr("data-restock");
  
  var rawRestockText = $("#currentSelection").attr("data-restock") || "";
  var restockText = rawRestockText.replace(/\s*\/\s*/g, "<br>");

  $(".stock-indicator").removeClass("active");
  if (stockNum == 1) {
    $(".stock-indicator.text-success").addClass("active");
    $(".delivery-stock-only").show();
    $(".delivery-stock-only .initial-salesbox").show();
    $(".product-restocks.default .timerBox").show();
    
    console.log('this changed - main indicator');
    $(".product-restocks.default p.hidden").hide();
    /* for initial select like in fridges // second groupsell*/
    if ($(".saleboxwrap.initial-salesbox .click-plus-2").hasClass("clicked")) {
    } else {
      setTimeout(() => {
        $(".saleboxwrap.initial-salesbox .click-plus-2").click();
      }, 1200);
    }

    $("#prism-vortex-8664261918947 .product-restocks").text();
    $("#prism-vortex-8664261918947 .product-restocks .timerBox").show();
    $(".product-restocks.default .timerBox, .product-restocks.default p.c-b, .product-restocks.default p.c, .product-restocks.default p.a").show();
    $(".product-restocks.default p.hidden, .product-restocks.default .timer-restock-preorder").hide();
    $(".product-restocks").removeClass('preorder');
    $(".custom-attributes.product-restocks.fans p, .product-restocks.default p.c-b").html(restockText);
    $(".product-form__checkout").text("GET IT NOW");
  } else if (stockNum == 2) {
    $(".stock-indicator.text-danger").addClass("active");
    $(".delivery-stock-only").hide();
    $(".product-form__checkout").text("GET IT NOW");
  } else if (stockNum == 0) {
  } else if (stockNum == 3) {
    $(".stock-indicator.text-warning").addClass("active");
    
    $(".delivery-stock-only").hide();
    

    $("#prism-vortex-8664261918947 .product-restocks").show();
    $("#prism-vortex-8664261918947 .product-restocks .variant-restock b").text(
      "Arrives in Late March",
    );
    
    $(".product-restocks.default .timerBox, .product-restocks.default p.c, .product-restocks.default p.a").hide();
    $(".product-restocks.default p.hidden, .custom-attributes.product-restocks.fans p").html(restockText);
    $(".product-restocks.default p.hidden").show();
    
    $('.product-restocks.default p.c-b, .product-restocks.default .timer-restock-preorder').html(restockText).show();
    $("#prism-vortex-8664261918947 .product-restocks .timerBox").hide();
    $(".product-form__checkout").text("PRE-ORDER NOW");
    console.log('stock preorder');
  }
}
/* DYNAMIC STOCK INDICATOR SELECT FOR DEFAULT SELECT OPTION */
$('.ProductSelect-product-template.default-select').on('change', function() {
    /* stock indicator */
    var stockIndicator = $(this).find('option:selected').data('stockindicatornum');
    var stockText = $(this).find('option:selected').data('restock');

    $("#currentSelection").attr("data-stockNum", stockIndicator);
    $("#currentSelection").attr("data-restock", stockText);

    updateStockIndicator();
    
});

/* =============================================
  		PROMO CODE DROPDOWN
================================================ */

jQuery(document).on("click", ".v_headWrap", function () {
  jQuery(this).toggleClass("opened");
  jQuery(this).next(".v_bodyWrap").slideToggle();
});

jQuery(document).on("click", ".v_codeRow", function () {
  if (!jQuery(this).hasClass("codeClicked")) {
    var THIS = jQuery(this);
    var code = jQuery(this).attr("data-code");
    jQuery(this).addClass("codeClicked");
    copyToClipboard(code, function () {
      
      $(".v_copiedMsg").hide();
      THIS.find(".v_copiedMsg").slideDown("fast").css("display", "flex");
      var d = setTimeout(function () {
        THIS.find(".v_copiedMsg").slideUp("fast");
        THIS.removeClass("codeClicked");
      }, 5000);
    });
  }
});

function copyToClipboard(code, cb) {
  var input = document.createElement("input");
  input.setAttribute("value", code);
  input.setAttribute("readonly", "");
  input.style.position = "absolute";
  input.style.left = "-9999px";
  document.body.appendChild(input);
  input.select();
  //for mobile devices this is mandatory
  input.setSelectionRange(0, 99999);
  document.execCommand("copy");
  document.body.removeChild(input);
  cb();
}

if ($(" #AirconSystemSelect-product-template").length) {
  /* manually set defaults on load
   ** IF recommended combinations are changed, update the variant IDs for each system
   */
  // var system2_default = "45530143391971"; //'43091513344170';
  // var system3_default = "45530143785187"; //'43099874001066';
  // var system4_default = "45530144375011"; //'43252427358378';

  /* DEFAULT ON LOAD */
  jQuery(document).ready(function ($) {
    const currentPath = window.location.pathname;
    //console.log(currentPath);
    if (
      currentPath === "/products/prism-neo" ||
      currentPath === "/products/prism-neo/" ||
      currentPath === "/collections/air-conditioners/products/prism-neo" ||
      currentPath === "/collections/air-conditioners/products/prism-neo/"
    ) {
      var system1_default = "46341394006243";
      var system2_default = "46341392990435";
      var system3_default = "46341393187043";
      var system4_default = "46341393907939";
    } else {
      /* for zero / original aircons */
      var system2_default = "45530143457507";
      var system3_default = "45530143850723";
      var system4_default = "45530144866531";
    }
    aircon_selection($(" #AirconSystemSelect-product-template"));
    aircon_pricechane($(" #ProductSelect-product-template"));

    //console.log("initial default fix:" + system2_default);
    /* manually set defaults on load
     ** IF recommended combinations are changed, update the variant IDs for each system
     */

    var def2 = " .system-2 option[value='" + system2_default + "']";
    default_pricing(def2);
    $(" .sys-radselec input#rad-sys2").click();
    $(" .system-1 option[value='" + system1_default + "']").attr(
      "selected",
      true,
    );
    $(" .system-2 option[value='" + system2_default + "']").attr(
      "selected",
      true,
    );
    $(" .system-3 option[value='" + system3_default + "']").attr(
      "selected",
      true,
    );
    $(" .system-4 option[value='" + system4_default + "']").attr(
      "selected",
      true,
    );
    $(" div#rad-sys2wrap").addClass("active");
    $(".dropdown-color-selector .colorbox-select.initial").click();
    $(".dropdown-wrapper.active .system-2").css("display", "block"); //manually set default
    setTimeout(function () {
      $(" .sys-radselec input#rad-sys2").click();
    }, 500);
  });

  //kinda repeated values haha but yeah, for now manually place on each function || default, on click of system selector, on click/change of dropdown
  const currentPath = window.location.pathname;
  if (
    currentPath === "/products/prism-neo" ||
    currentPath === "/products/prism-neo/" ||
    currentPath === "/collections/air-conditioners/products/prism-neo" ||
    currentPath === "/collections/air-conditioners/products/prism-neo/"
  ) {
    var system2_default = "46341392990435";
    var system3_default = "46341393187043";
    var system4_default = "46341393907939";
  } else {
    /* for zero / original aircons */
    var system2_default = "45530143457507";
    var system3_default = "45530143850723";
    var system4_default = "45530144866531";
  }

  /* DROPDOWN SELECTOR / COLOR SELECTOR */
  $(".dropdown-color-selector .colorbox-select").click(function () {
    var colorSelected = $(this).attr("data-display");
    $(
      ".dropdown-color-selector .ctm.product-selector-wrapper .initial-group",
    ).text(colorSelected);

    var CurrentUnit = $(".unit-selection .sys-radselec.active input").val();
    if (CurrentUnit) {
      CurrentUnit = CurrentUnit.replace("S", "s");
      //console.log(CurrentUnit);
      //console.log("to lowercase ok");
    } else {
      console.log("error in current unit selection");
    }
    //console.log("current unit:" +CurrentUnit);
    var selectedType = $(this).attr("data-type");
    if (selectedType == "neo-white") {
      var system1_default = "46341394006243";
      var system2_default = "46341392990435";
      var system3_default = "46341393187043";
      var system4_default = "46341393907939";
    } else {
      /* space grey */
      var system1_default = "46360413929699";
      var system2_default = "46360412913891";
      var system3_default = "46360413110499";
      var system4_default = "46360413831395";
    }
    if (CurrentUnit == "system-1") {
      var useSystem = system1_default;
    } else if (CurrentUnit == "system-2") {
      var useSystem = system2_default;
    } else if (CurrentUnit == "system-3") {
      var useSystem = system3_default;
    } else if (CurrentUnit == "system-4") {
      var useSystem = system4_default;
    }
    $(".dropdown-form-to-select #currentSelection").attr(
      "data-dropdown-name",
      selectedType,
    );

    aircon_selection($(" #AirconSystemSelect-product-template"));
    aircon_pricechane(
      $(".form-selected.active #ProductSelect-product-template"),
    );

    /* manually set defaults on load
     ** IF recommended combinations are changed, update the variant IDs for each system
     */

    var def2 = "." + CurrentUnit + " option[value='" + useSystem + "']";
    default_pricing(def2);
    //$(" .sys-radselec input#rad-sys2").click();
    $(".unit-selection .sys-radselec.active input").click();
    $(" .system-1 option[value='" + system1_default + "']").attr(
      "selected",
      true,
    );
    $(" .system-2 option[value='" + system2_default + "']").attr(
      "selected",
      true,
    );
    $(".dropdown-form-to-select #currentSelection").attr(
      "data-variant",
      useSystem,
    );
    $(" .system-3 option[value='" + system3_default + "']").attr(
      "selected",
      true,
    );
    $(" .system-4 option[value='" + system4_default + "']").attr(
      "selected",
      true,
    );

    $(".dropdown-with-selector").removeClass("initial");
    $(".dropdown-with-selector").addClass("hideme");
    $(".dropdown-with-selector." + CurrentUnit).removeClass("hideme");
    $(".dropdown-with-selector." + CurrentUnit).addClass("initial");

    //$('.dropdown-with-selector .initial').val();
    //$(" div#rad-sys2wrap").addClass("active");
    /* set default based on selected unit on change of color */
  });

  /* ON CLICK OF UNIT SELECTION */
  $(" input[name='aircon_select']").on("change", function () {
    const currentPath = window.location.pathname;

    var selectedType = $("#currentSelection").attr("data-dropdown-name");
    if (selectedType == "neo-white") {
      var system1_default = "46341394006243";
      var system2_default = "46341392990435";
      var system3_default = "46341393187043";
      var system4_default = "46341393907939";
    } else if (selectedType == "neo-grey") {
      /* space grey */
      var system1_default = "46360413929699";
      var system2_default = "46360412913891";
      var system3_default = "46360413110499";
      var system4_default = "46360413831395";

    } else {
      /* for zero / original aircons */
      var system2_default = "45530143457507";
      var system3_default = "45530143850723";
      var system4_default = "45530144866531";

    }

    aircon_selection(this);
    $(".sys-radselec").removeClass("active");
    $(this).parent().addClass("active");
    //var selectval = $("#AirconSystemSelect-product-template").val();
    var selectval = $(' input[name="aircon_select"]:checked').val();

    if (selectval == "System-1") {
      $(" select.ProductSelect-product-template").hide();
      $(" select.ProductSelect-product-template").removeClass(
        "product-form__variants2",
      );
      $(" select.ProductSelect-product-template.system-1").show();
      $(" select.ProductSelect-product-template.system-1").addClass(
        "product-form__variants2",
      );
      $(" .btu-combi").css("display", "flex");

      /* manually set options on change of units */
      var selection = $(
        ".form-selected .ProductSelect-product-template.system-1",
      );
      if ($(selection).hasClass("changed")) {
        var selectedVal = $(
          ".form-selected select.ProductSelect-product-template.system-1 option:selected",
        ).val();
        var def2 = " .system-1 option[value='" + selectedVal + "']";
        default_pricing(def2);
        $(".dropdown-form-to-select #currentSelection").attr(
          "data-variant",
          selectedVal,
        );
      } else {
        var def2 = " .system-1 option[value='" + system1_default + "']";
        default_pricing(def2);
        $(".dropdown-form-to-select #currentSelection").attr(
          "data-variant",
          system1_default,
        );
      }
    } else if (selectval == "System-2") {
      $(" select.ProductSelect-product-template").hide();
      $(" select.ProductSelect-product-template").removeClass(
        "product-form__variants2",
      );
      $(" select.ProductSelect-product-template.system-2").show();
      $(" select.ProductSelect-product-template.system-2").addClass(
        "product-form__variants2",
      );
      $(" .btu-combi").css("display", "flex");

      /* manually set options on change of units */
      var selection = $(
        ".form-selected .ProductSelect-product-template.system-2",
      );
      if ($(selection).hasClass("changed")) {
        var selectedVal = $(
          ".form-selected select.ProductSelect-product-template.system-2 option:selected",
        ).val();
        var def2 = " .system-2 option[value='" + selectedVal + "']";
        default_pricing(def2);
        $(".dropdown-form-to-select #currentSelection").attr(
          "data-variant",
          selectedVal,
        );
      } else {
        var def2 = " .system-2 option[value='" + system2_default + "']";
        default_pricing(def2);
        $(".dropdown-form-to-select #currentSelection").attr(
          "data-variant",
          system2_default,
        );
      }
    } else if (selectval == "System-3") {
      $(" select.ProductSelect-product-template").hide();
      $(" select.ProductSelect-product-template").removeClass(
        "product-form__variants2",
      );
      $(" select.ProductSelect-product-template.system-3").show();
      $(" select.ProductSelect-product-template.system-3").addClass(
        "product-form__variants2",
      );
      $(" .btu-combi").css("display", "flex");

      /* manually set options on change of units */
      var selection = $(
        ".form-selected .ProductSelect-product-template.system-3",
      );
      if ($(selection).hasClass("changed")) {
        var selectedVal = $(
          ".form-selected select.ProductSelect-product-template.system-3 option:selected",
        ).val();
        var def2 = " .system-3 option[value='" + selectedVal + "']";
        default_pricing(def2);
        $(".dropdown-form-to-select #currentSelection").attr(
          "data-variant",
          selectedVal,
        );
      } else {
        var def2 = " .system-3 option[value='" + system3_default + "']";
        default_pricing(def2);
        $(".dropdown-form-to-select #currentSelection").attr(
          "data-variant",
          system3_default,
        );
      }
    } else if (selectval == "System-4") {
      $(" select.ProductSelect-product-template").hide();
      $(" select.ProductSelect-product-template").removeClass(
        "product-form__variants2",
      );
      $(" select.ProductSelect-product-template.system-4").show();
      $(" select.ProductSelect-product-template.system-4").addClass(
        "product-form__variants2",
      );
      $(" .btu-combi").css("display", "flex");

      /* manually set options on change of units */
      var selection = $(
        ".form-selected .ProductSelect-product-template.system-4",
      );
      if ($(selection).hasClass("changed")) {
        var selectedVal = $(
          ".form-selected select.ProductSelect-product-template.system-4 option:selected",
        ).val();
        var def2 = " .system-4 option[value='" + selectedVal + "']";
        default_pricing(def2);
        $(".dropdown-form-to-select #currentSelection").attr(
          "data-variant",
          selectedVal,
        );
      } else {
        var def2 = " .system-4 option[value='" + system4_default + "']";
        default_pricing(def2);
        $(".dropdown-form-to-select #currentSelection").attr(
          "data-variant",
          system4_default,
        );
        $("#currentSelection").attr("data-variant", system4_default);

      }
    } else {
      $("select.ProductSelect-product-template").hide();
      $(".preorder").removeClass("active");
      $("#initateCheckout").text("GET IT NOW");
      console.log('this changed');
      $(".btu-combi").hide();
    }
    /* due to the saver price being displayed when selecting aircon */
    const bundleSaver = $(
      '[name="aircon_bundle_select"][value="bundle-saver"]',
    );
    if (!bundleSaver.is(":checked")) {
      bundleSaver.prop("checked", true);
      $('[name="aircon_bundle_select"]:checked').trigger("change");
    }
    $(".form-selected .dropdown-with-selector").removeClass("hideme initial");
    setTimeout(function () {
      manualComparePercentage();
    }, 500);
  });
  $(" .ProductSelect-product-template.system-1").on("change", function () {
    $(" .ProductSelect-product-template.system-1").addClass("changed");

    aircon_pricechane(this);
  });
  $(" .ProductSelect-product-template.system-2").on("change", function () {
    $(" .ProductSelect-product-template.system-2").addClass("changed");
    aircon_pricechane(this);
  });
  $(" .ProductSelect-product-template.system-3").on("change", function () {
    $(" .ProductSelect-product-template.system-3").addClass("changed");
    aircon_pricechane(this);
  });
  $(" .ProductSelect-product-template.system-4").on("change", function () {
    $(" .ProductSelect-product-template.system-4").addClass("changed");
    aircon_pricechane(this);
  });
  function default_pricing(selVariant) {
    /* on changing of units and on first load default */
    if ($(selVariant).length) {
      $("#currentSelection").attr(
        "data-price",
        $(selVariant).attr("data-price"),
      );
      $("#currentSelection").attr(
        "data-compare",
        $(selVariant).attr("data-compare-price").replace("$", ""),
      );
      $("#currentSelection").attr(
        "data-voucher",
        $(selVariant).attr("data-voucher"),
      );
    }
    $("#ProductPrice-product-template").html(
      '<span class="currency_sym_pro"></span>' +
        $("" + selVariant + "").attr("data-price-show"),
    );
    $("#ProductPrice-product-template").attr(
      "content",
      $("" + selVariant + "").attr("data-price-show"),
    );
    $("#ComparePrice-product-template").html(
      '<span class="currency_sym_pro"></span>' +
        $("" + selVariant + "").attr("data-compare-price"),
    );
    $("#compare_precntage, .comparetooltip").html(
      $("" + selVariant + "").attr("data-compare-percentage"),
    );
    $("#compare_save").html(
      $("" + selVariant + "").attr("data-compare-diffrent"),
    );

    /*
    $("#voucher-price, .voucher1").html(
      $("" + selVariant + "").attr("data-compare-voucher")
    );
    */
    $(".product-restocks.tst p").text(
      $("" + selVariant + "").attr("data-restock"),
    );

    $('[name="aircon_bundle_select"]:checked').trigger("change");

    /* stock indicator */
    var stockIndicator = $("" + selVariant + "").attr("data-stockIndicatorNum");

    $("#currentSelection").attr("data-stockNum", stockIndicator);

    /* grab payments */

    /* change voucher price */
    var ab = $("span#voucher-price").text().replace("$", "");
    var abc = ab.replace(",", "");

    var bd = $(".payment-alt-options .data-eq.grab-info").attr("data-discount");
    var atd = $(".payment-alt-options .data-eq.atome-info").attr("data-discount");
    var eq = parseInt(abc) / bd;
    var atome = parseInt(abc) / atd;
    eq = Math.round(eq);
    atome = Math.round(atome);
    $(".payment-alt-options .price-value.grab-info").text(eq);
    $(".grabpay-modal .grabpay-box .pay-details .price span").text(
      parseInt(eq),
    );
    /* atome payments */
    var bd = $(".payment-alt-options .data-eq.atome-info").attr(
      "data-discount",
    );

    $(".payment-alt-options .price-value.atome-info").text(atome);
    /* hide grab if voucher price is higher than 3000 
    if (abc > "3000") {
      //console.log('hide grab');
      $(".grab-box .grab-info").addClass("hide");
      $(".grab-box .grab-img").addClass("hide");
    } else {
      $(".grab-box .grab-info").removeClass("hide");
      $(".grab-box .grab-img").removeClass("hide");
    }
    */

    var voucherTest = $("" + selVariant + "").attr("data-compare-voucher");

    $("#voucher-price, .voucher1").text(voucherTest);
    manualComparePercentage();
  }

  function aircon_pricechane(cObj) {
    console.log("PRICECHANE FUNCTION: " + cObj.value);

    if (cObj.value == undefined || cObj.value == "") {
      //console.log("price_change 0")
      /*$('.product-price-wrap').css({'visibility':'hidden','height':'0'});
      $('.payment-alt-options').css({'visibility':'hidden','height':'0'}).addClass('hidden');*/
    } else {
      $("#ProductPrice-product-template").html(
        '<span class="currency_sym_pro"></span>' +
          $("option:selected", cObj).attr("data-price-show"),
      );
      $("#ProductPrice-product-template").attr(
        "content",
        $("#ProductSelect-product-template").attr("data-price-show"),
      );
      $("#ComparePrice-product-template").html(
        '<span class="currency_sym_pro"></span>' +
          $(" option:selected", cObj).attr("data-compare-price"),
      );
      $("#compare_precntage, .comparetooltip").html(
        $(" option:selected", cObj).attr("data-compare-percentage"),
      );
      $("#compare_save").html(
        $(" option:selected", cObj).attr("data-compare-diffrent"),
      );

      /*
      $("#voucher-price, .voucher1").html(
        $(" option:selected", cObj).attr("data-compare-voucher")
      );
      */

      $(' [name="aircon_bundle_select"]:checked').trigger("change");

      $(".product-price-wrap").css({ visibility: "", height: "100%" });
      $(".payment-alt-options")
        .css({ visibility: "", height: "100%" })
        .removeClass("hidden");

      /* change voucher price */
      var ab = $("span#voucher-price").text().replace("$", "");
      var abc = ab.replace(",", "");

      // update climate voucher price
      let price = $(" option:selected", cObj)
        .attr("data-compare-voucher")
        ?.replace("$", "")
        .replace(",", "");
      price -= window.cv_price;
      $(".voucher-pricing .tooltip .voucher-wrap .voucher-price").html(
        theme.Currency.formatMoney(price * 100).replace(".00", ""),
      );
      if ($("#shopify-section-product-template-zero").length > 0) {
        let product_price = $("option:selected", cObj)
          .attr("data-compare-voucher")
          ?.replace("$", "")
          .replace(",", "");
        let grabInstallment = $(
          ".grabpay-box .grabpay-content .flex-item:last-child .price span",
        );
        grabInstallment?.html(
          theme.Currency.formatMoney(
            Math.floor(parseInt(product_price) / 4) * 100,
          )
            .replace("$", "")
            .replace(".00", ""),
        );
      }
      var voucherTest = $(" option:selected", cObj).attr(
        "data-compare-voucher",
      );
      $("#voucher-price, .voucher1").text(voucherTest);
      /* grab payments */

      var bd = $(".payment-alt-options .data-eq.grab-info").attr(
        "data-discount",
      );
      var eq = parseInt(abc) / bd;
      eq = Math.round(eq);
      $(".payment-alt-options .price-value.grab-info").text(eq);
      $(".grabpay-modal .grabpay-box .pay-details .price span").text(
        parseInt(eq),
      );
      /* atome payments */
      var bd = $(".payment-alt-options .data-eq.atome-info").attr(
        "data-discount",
      );
      var eq = parseInt(abc) / bd;
      $(".payment-alt-options .price-value.atome-info").text(parseInt(eq));

      /* hide grab if voucher price is higher than 3000 
      if (abc > "3000") {
        //console.log('hide grab');
        $(".grab-box .grab-info").addClass("hide");
        $(".grab-box .grab-img").addClass("hide");
      } else {
        $(".grab-box .grab-info").removeClass("hide");
        $(".grab-box .grab-img").removeClass("hide");
      }
      */
      var preorder = $("option:selected", cObj).attr("data-order");
      if (preorder == "preorder") {
        $(".preorder").addClass("active");
        $("#initateCheckout").text("PRE-ORDER NOW");
        console.log('testing');
      } else {
        $(".preorder").removeClass("active");
        $("#initateCheckout").text("GET IT NOW");
        console.log('this changed');
      }
      /* stock indicator */
      var stockIndicator = $(" option:selected", cObj).attr(
        "data-stockIndicatorNum",
      );
      $("#currentSelection").attr("data-variant", cObj.value);
      $("#currentSelection").attr("data-stockNum", stockIndicator);
    }

    manualComparePercentage();
  }

  function aircon_selection(cObj) {
    if (cObj.value == undefined) {
      cObj.val("-");
      $(" #ProductSelect-product-template").hide();
      $(" #ProductSelect-product-template").val("");
    }
    if ($("." + cObj.value).length > 0) {
      $(" #ProductSelect-product-template").show();
      $(" #ProductSelect-product-template option").hide();
      $(" #ProductSelect-product-template").val("");
      $("." + cObj.value).show();
    } else {
      $(" #ProductSelect-product-template").hide();
      $(" #ProductSelect-product-template").val("");
    }
  }
}
$(" input[name='aircon_bundle_select']").on("change", function () {
  setTimeout(function () {
    manualComparePercentage();
  }, 500);
});
function manualComparePercentage() {
  var clickedPrice = $("#voucher-price").text().replace("$", "");
  var clickedCompare = $("#ComparePrice-product-template")
    .text()
    .replace("$", "");
  //var myselVariant = $("#currentSelection").attr("data-variant")
  //clickedPrice = $("option[value= " + myselVariant + "]").attr("data-price");
  //clickedCompare = $("option[value= " + myselVariant + "]").attr("data-price");

  myInteger = parseInt(clickedCompare.replace(/\,/g, ""));
  myPrice = parseInt(clickedPrice.replace(/\,/g, ""));

  var clickedComparePercentage = Math.round(
    ((myInteger - myPrice) / myInteger) * 100,
  );
  $("#compare_precntage, .comparetooltip").text(
    clickedComparePercentage + "% OFF",
  );
  /* manually change climate voucher value on change of color // for neo */
  var climateVoucher = 400;
  var updateClimateVoucher = parseInt(myPrice - climateVoucher);
  $(".climate-voucher-tooltip .voucher-price").text(
    "$" + numberWithCommas(updateClimateVoucher),
  );
  updateStockIndicator();
}

/* on click selectors / hide and show sections / for neo */
$(".dropdown-color-selector .colorbox-select").click(function () {
  var selectedType = $(this).attr("data-type");
  var selectedColor = $(this).attr("data-color");
  $(".dropdown-color-selector .colorbox-select").removeClass("active");
  $(this).addClass("active");
  $(".dropdown-wrapper").removeClass("active form-selected");
  $(".dropdown-wrapper." + selectedType).addClass("active form-selected");
  $(".form-wrap-item .product-form").removeClass("form-selected");
  $(".form-wrap-item." + selectedType + " .product-form").addClass(
    "form-selected",
  );

  $(".product-single__thumbnails-items").removeClass("initial-fix active");
  $(".product-single__thumbnails-items." + selectedColor).addClass(" active");
  $(".product-single__thumbnails-items.main a").removeClass("active-thumb");
  $(".product-single__thumbnails-items." + selectedColor + " a").addClass(
    "active-thumb",
  );
  $(".dropdown-wrapper.active .system-2").css("display", "block"); //manually set default
  updateThumbnail();
  updateVoucher();
});
function numberWithCommas(number) {
  var parts = number.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}
/* =============================================
  		AIRCONS CUSTOM SELECT
================================================ */

jQuery(document).ready(function ($) {
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    var titles = $(".startposition").position();
    var end = $(".endposition").position();

    if (!titles || !end) return;

    if (scroll >= titles.top && scroll <= end.top) {
      $(".ac-table-scroll").addClass("active");
    } else {
      $(".ac-table-scroll").removeClass("active");
    }
  });
  window.onresize = function () {
    $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      var titles = $(".startposition").position();
      var end = $(".endposition").position();

      if (!titles || !end) return;

      if (scroll >= titles.top && scroll <= end.top) {
        $(".ac-table-scroll").addClass("active");
      } else {
        $(".ac-table-scroll").removeClass("active");
      }
    });
  };
});
/* on load open write a review section based on url */
jQuery(window).bind("load", function () {
  if (window.location.href.indexOf("#judgeme_product_reviews") > -1) {
    $(".jdgm-write-rev-link").text("Cancel Review");
    $(".jdgm-write-rev-link").addClass("close-form-btn");
    $(".jdgm-widget-actions-wrapper a").attr(
      "aria-expanded",
      function (i, attr) {
        return attr == "true" ? "false" : "true";
      },
    );
    $(".jdgm-form-wrapper").css("display", "block");
  }
});

/**
 * FUNCTION FOR AIR PURIFIERS SUBSCRIPTIONS
 */
function addAPReplacementFilterTotalPriceText() {
  const priceWrap = document.querySelector(".product-price-wrap");
  if (!priceWrap) return;
  const text = document.createElement("p");
  text.classList.add("hide", "ap-filter-total");
  text.style.marginBottom = "10px";
  priceWrap.append(text);
}
addAPReplacementFilterTotalPriceText();
const del_freq_input = document.querySelectorAll(
  'input[name="options[del_freq]"]',
);
del_freq_input.forEach((input) => {
  input.addEventListener("change", function () {
    // UI changes - start
    const delFreqStr = this.dataset.delFreq || "0";
    const delFreq = parseInt(delFreqStr);
    const paymentPlan = document.querySelector(".variant-payment-plan");
    const variantOption = paymentPlan.querySelector(
      `.variant-option[data-del-freq="${delFreq}"]`,
    );
    const apFilterTotalText = document.querySelector(".ap-filter-total");

    if (delFreq > 0 && (!paymentPlan || !variantOption)) {
      alert("Something went wrong.");
      return;
    }

    if (delFreq == 0) {
      paymentPlan.classList.add("hide");
      apFilterTotalText.classList.add("hide");
    } else {
      paymentPlan.classList.remove("hide");
      paymentPlan.querySelectorAll(".variant-option").forEach((element) => {
        element.classList.add("hide");
      });
      variantOption.classList.remove("hide");
      apFilterTotalText.classList.remove("hide");
    }
    // UI changes - end

    let variantId = null;
    let price = 0;
    let total = 0;
    if (delFreqStr == 0) {
      variantId = this.value;
      price = (this.dataset.price / 100).toFixed(2);
    } else {
      const selectElem = variantOption.querySelector("select");
      variantId = selectElem.value;
      const totalPrice =
        selectElem.options[selectElem.selectedIndex].dataset.price;
      const frequency =
        selectElem.options[selectElem.selectedIndex].dataset.frequency;
      price = totalPrice / frequency / 100;
      total = totalPrice / 100;
    }

    if (total > 0) {
      apFilterTotalText.innerHTML = `Total: $${total}`;
    } else {
      apFilterTotalText.innerHTML = "";
    }

    $("#currentSelection").attr("data-variant", variantId);
    $("#currentSelection").attr("data-price", price);

    updateLinks();
    updatePrice();
  });
});
const del_freq_select = document.querySelectorAll(
  ".variant-payment-plan select",
);
del_freq_select.forEach((select) => {
  select.addEventListener("change", function () {
    $("#currentSelection").attr("data-variant", this.value);

    const totalPrice = this.options[this.selectedIndex].dataset.price;
    const frequency = this.options[this.selectedIndex].dataset.frequency;
    const price = totalPrice / frequency / 100;
    $("#currentSelection").attr("data-price", price);

    const apFilterTotalText = document.querySelector(".ap-filter-total");
    apFilterTotalText.innerHTML = `Total: $${(totalPrice / 100).toFixed(2)}`;

    updateLinks();
    updatePrice();
  });
});

/* hide climate voucher on click of black-inox 
$(document).ready(function () {
  if (
    window.location.href.indexOf("prism-purefresh-tmf530-refrigerator") > -1
  ) {
    $(".variant-item").click(function () {
      if ($(".variant-black-inox").hasClass("active")) {
        $(
          ".tooltip.climate-voucher-tooltip, .buy-with-climate-voucher-container"
        ).css("display", "none");
      } else {
        $(
          ".tooltip.climate-voucher-tooltip, .buy-with-climate-voucher-container"
        ).css("display", "block");
      }
    });
  }
});
*/

$(".with-variantImage input[type='radio']").on("change", function () {
  $("#currentSelection").attr("data-variant", $(this).val());
  $("#currentSelection").attr("data-price", $(this).attr("data-price"));
  $("#currentSelection").attr("data-compare", $(this).attr("data-compare"));
  $(".product-single__thumbnails-items").removeClass("main").addClass("hide");
  $(`.product-single__thumbnails-items.${$(this).attr("data-title")}`)
    .addClass("main")
    .removeClass("hide");
  $(
    `.product-single__thumbnails-items.${$(this).attr("data-title")} a`,
  ).addClass("active-thumb");
  $("[data-variant_title]").html($(this).attr("data-variant_title") || "");
  $(".variant_desc").html($(this).attr("data-variant_desc") || "");

  const url = new URL(window.location.href);
  url.searchParams.set("variant", $(this).val());
  window.history.replaceState(null, "", url.toString());

  updateLinks();
  updatePrice();
  updateInstallment();
  updateThumbnail();
});
if ($(".with-variantImage").length) {
  $(".with-variantImage input[type='radio']:checked").trigger("change");
}

/* ON LOAD CLICK OF SELECTOR BASED ON PAGE */
jQuery(document).ready(function ($) {
  const currentUrl = window.location.href;
  if (
    currentUrl ===
      "https://prismplus.sg/products/aura-smart-air-purifier-filter?3-months" ||
    currentUrl ===
      "https://prismplus.sg/collections/smart-air-purifiers/products/aura-smart-air-purifier-filter?3-months" ||
    currentUrl ===
      "https://prismplus.sg/products/vortex-replacement-filter?3-months" ||
    currentUrl ===
      "https://prismplus.sg/collections/smart-air-purifiers/products/vortex-replacement-filter?3-months" ||
    currentUrl ===
      "https://prismplus.sg/products/vortex-pro-replacement-filter?3-months" ||
    currentUrl ===
      "https://prismplus.sg/collections/smart-air-purifiers/products/vortex-pro-replacement-filter?3-months"
  ) {
    $("#3-months-4-sets-yr input").prop("checked", true);
    $(".variant-payment-plan .variant-option").addClass("hide");
    $(".variant-payment-plan, #payment-plan-4").removeClass("hide");
  }

  function getUrlParameters() {
    const params = {};
    const queryString = window.location.search;
    if (queryString) {
      const urlParams = new URLSearchParams(queryString);
      for (const [key, value] of urlParams.entries()) {
        if (params[key]) {
          // If parameter already exists, convert to array and add new value
          if (!Array.isArray(params[key])) {
            params[key] = [params[key]];
          }
          params[key].push(value);
        } else {
          params[key] = value;
        }
      }
    }
    return params;
  }

  const urlParameters = getUrlParameters();
  var pvariant = urlParameters.variant;
  var ptype = urlParameters.ptype;
  var pcolor = urlParameters.pcolor;

  if (ptype != null || ptype != undefined) {

    setTimeout(function () {
      $(".type-box." + ptype).click();
    }, 2000);
  } else {
    setTimeout(function () {
      $(".type-box.initial.active").click();
    }, 2000);
  }

  if (pcolor != null || pcolor != undefined) {
    setTimeout(function () {
      $(".show.color-box." + pcolor).click();
      $(".sel-wrapper .item.swatch."+pcolor).click();
      
      //$(".active." + pcolor).click();
      
      $(".type-box.active").click();
      
    }, 2000);

    /* on click not working, so manually placed it here.. for laundry bundles.. maybe due to multiple colors */
      if(pcolor == 'black'){
        setTimeout(function () {
          $(".washer-color .variant-black").click();
        }, 2000);
        setTimeout(function () {
          $(".colorbox-select.racks-color .variant-space-grey").click();
        }, 2200);
      }else if(pcolor == 'white'){
        setTimeout(function () {
          $(".washer-color .variant-white").click();
        }, 2000);
        setTimeout(function () {
          $(".colorbox-select.racks-color .variant-pearl-white").click();
        }, 2200);
      }else if(pcolor == 'space-grey'){
       
        setTimeout(function () {
           $(".washer-color .variant-space-grey").click();
           $(".washer-color .variant-black").click();
        }, 2000);
        setTimeout(function () {
          $(".colorbox-select.racks-color .variant-space-grey").click();
        }, 2200);
      }
  }

  /* quickfixes on load */
  /* sentinel and spectre bundle */
  $("#spectre-bundle-2026-9137790386403 #currentSelection").attr(
    "data-voucher",
    "250"
  );
  $("#sentinel-bundle-2026-9137790222563 #currentSelection").attr(
    "data-voucher",
    "200"
  );

  $("#sentinel-bundle-2026-9137790222563 .dynamicCode").html("LOCK200");
  $("#spectre-bundle-2026-9137790386403 .dynamicCode").html("LOCK250");
  //$('.free-gift .info-wrapper .title-wrapper .free-tag').text('EXCLUSIVE PROMO');
});

/* adjust checkout button based on apple pay */
document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver(() => {
    const applePayBtn = document.querySelector(
      ".shopify-payment-button__button--apple-pay",
    );

    if (!applePayBtn) return;
    if (applePayBtn) {
      console.log("with apple pay");
    } else {
      console.log("no apple pay");
    }
    const rect = applePayBtn.getBoundingClientRect();

    console.log("Apple Pay width:", rect.width);
    console.log("Apple Pay height:", rect.height);

    const checkoutBtn = document.querySelector("#cart-initiateCheckout");
    if (checkoutBtn && rect.height > 0) {
      checkoutBtn.style.height = rect.height + "px";
      checkoutBtn.style.lineHeight = rect.height + "px";
    }

    // Stop observing once found
    observer.disconnect();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
function syncApplePaySize() {
  const applePayBtn = document.querySelector(
    ".shopify-payment-button__button--apple-pay",
  );
  const checkoutBtn = document.querySelector("#cart-initiateCheckout");

  if (!applePayBtn || !checkoutBtn) return;

  const rect = applePayBtn.getBoundingClientRect();
  if (rect.height > 0) {
    checkoutBtn.style.height = rect.height + "px";
    checkoutBtn.style.lineHeight = rect.height + "px";
  }
}

const observer = new MutationObserver(syncApplePaySize);
observer.observe(document.body, { childList: true, subtree: true });

document.addEventListener("DOMContentLoaded", function () {
  const overlay = document.querySelector(".overlay-table h2");

  if (overlay) {
    overlay.textContent = overlay.textContent.replace(/^PRISM\+\s*/, "");
  }
});

function disableVariants() {
  $(
    "#shopify-section-template--20285438787811__product_template_7aMCpM .variant-sentinel-copper-rose",
  ).hide(); //sentinel
  $(
    "#shopify-section-template--20285438755043__product_template_7aMCpM .variant-sentinel-copper-rose",
  ).hide(); //sentinel bundle
}

$(document).ready(function () {
  disableVariants();
});

//PRE-ORDER STATUS OF MONSOON 105 SPACE GREY
if (window.location.pathname === '/products/laundry-rack-and-washer-bundle') {

  const PREORDER_RESTOCK = 'Laundry Rack - Delivers in 1-2 working days / Washer - Deliver from 22 August onwards';

  const preorderRules = [
    {
      model: 'Cyclonex',
      capacities: ['WF 135x'],
      colors: ['Matte Black']
    }
  ];
  
  function updatePreorderState() {

    const model = $('.option-wrapper[data-type="model"] .item.active').data('value');
    const capacity = $('.option-wrapper[data-type="capacity"] .item.active').data('value');
    const color = $('.option-wrapper[data-type="washer_color"] .item.active').data('value');

    const isPreorder = preorderRules.some(rule =>
      rule.model === model &&
      rule.capacities.includes(capacity) &&
      rule.colors.includes(color)
    );

    if (!isPreorder) return;

    $('#currentSelection')
      .attr('data-stocknum', '3')
      .attr('data-restock', PREORDER_RESTOCK);

    updateStockIndicator();
  }

  $(document).on('click', '.option-wrapper .item', function () {
    setTimeout(updatePreorderState, 20);
  });

  $(document).ready(updatePreorderState);

}


